import {
  AfterViewInit,
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import { PropertyModel } from "../models/property.model";
import Swal from "sweetalert2";

import { PropertiesService } from "../services/properties.services";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/services/auth.service";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { ProposalsService } from "../../proposals/services/proposals.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { User } from "src/app/core/models/auth.models";
import { PropertyValidationRulesService } from "src/app/core/services/propertyValidationRules.service";
import { PropertyRuleSection } from "../../entity/config/properties/models/property-validation-rules";
import { NotificationService } from "src/app/core/services/notification.service";
import { CookieService } from "ngx-cookie-service";
import { DocExtractionResult } from "./ai-doc-wizard/ai-doc-wizard.component";
import { AiIntegrationsService } from "src/app/core/services/ai-integrations.service";
import {
  AiExtractionStateService,
  AiFieldProvenance,
} from "src/app/core/services/ai-extraction-state.service";
import { AiUsageLinkStateService } from "src/app/core/services/ai-usage-link-state.service";
import { PropertyExtractionService } from "src/app/core/services/property-extraction.service";
import { AiFormPatch } from "./ai-extraction/ai-extraction-patch.util";
import {
  AiCurrentValues,
  AiLookups,
} from "./ai-extraction/ai-extraction.models";
import { AiProvenanceSources } from "./ai-extraction/ai-provenance.directive";
import { take } from "rxjs/operators";
import { ContactsService } from "../../contacts/services/contacts.service";
import { FilesService } from "src/app/core/services/files.service";
import {
  extractMissingFields,
  missingFieldsHtml,
} from "src/app/core/utils/missing-fields-alert.util";
import { MediationContractComponent } from "src/app/shared/modals/mediation-contract/mediation-contract.component";
import { buildCharacteristicsPayload } from "../utils/characteristics-payload.util";

type ErrorItem = { key: string; type: { warning?: true; required?: true } };

type WarnDef<T> = {
  uiKey: string; // ex: "zip-code"
  ruleKey: string; // ex: "address.zipCode"
  invalidOnUpdate: (data: T) => boolean;
};

import { ActivityLogsService } from "src/app/core/services/logs.service";
@Component({
  selector: "app-create-edit",
  templateUrl: "./create-edit.component.html",
  styleUrls: ["./create-edit.component.scss"],
})
export class CreateEditComponent
  implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  textAddOrUpdateModalTitle: string = "t-add-property";
  textAddOrUpdateModal: string = "t-save";
  @ViewChild("content", { static: true }) content!: ElementRef;
  /**
   * O separador de mediação (13) é renderizado pelo `ngbNav` só quando está
   * ativo — fora dele o filho é `undefined` (ver `openCmiGeneratorWhenRendered`).
   */
  @ViewChild(MediationContractComponent) mediationContract?: MediationContractComponent;
  propertyForm!: FormGroup;

  subscriptions: Subscription = new Subscription();
  nabTabActive = 0;
  private currentNavTabSubject!: BehaviorSubject<number>;

  @Input() openModaltSubject$!: BehaviorSubject<number>;

  warningSubject$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  /**
   * Avisos só da "ficha base" (detalhes, morada, zonas, anúncio, contactos) —
   * sem CMI, multimédia, documentos nem a ativação. É o que a referência
   * definitiva exige; o resto continua a contar para validar/publicar.
   */
  baseWarningSubject$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  requiredSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  detailsForm: any;
  @Input() dataToFormInitDetails: any;

  @Input() prospectingId: any;

  propertyAreasNearbyData: any;
  @Input() dataToFormInitAreasNearby: any;

  @Input() dataToFormInitAddress: any;
  addressForm: any;

  propertyCharateristicsData: any;
  @Input() dataToFormInitChar: any;

  @Input() dataToFormInitAdvertisement: any;
  propertyAdvertisementData: any;

  propertyMultimediaData: any;

  @Input() dataToFormInitAgents: any;
  dataToFormInitAgentsDetails: any;

  propertyAgentsData: any;
  propertyCmiData: any = { errors: [], valid: true };

  propertyCostumersContactsData: any;
  propertyOwnersContactsData: any;

  @Input() dataToFormInitPortals: any;
  propertyPortalsData: any;

  propertyProposalsData: any;

  @Input() propertyDocumentsData: any;

  @Input() canActivateProperties!: { available: boolean; quantity: number };

  @Input() property: any;

  requiredOwner: boolean = false;
  store$!: Observable<any>;
  submitted: boolean = false;
  modalClosed: boolean = false;

  showTabAreasNearby = false;
  showTabDetails = false;
  showTabAddress = false;
  showTabAreasChar = false;
  showTabAdvertisement = false;
  showTabAgents = false;
  isUpdate: boolean = false;
  propertyUpdate: any;
  propertyId: any;
  isSave = false;
  activeId!: number;
  portalsLogs: number = 0;
  canChangeBusinessStatus: boolean = true;
  statusList!: any[];
  subscriptionDataTabAgents!: Subscription;
  subscriptionCkeckWarning!: Subscription;
  private formWatchObserver: MutationObserver | null = null;
  /** Se o componente morre antes dos 300ms, o timeout criaria um observer órfão. */
  private formWatchTimeout: any = null;
  subscription: Subscription;
  modalFef!: NgbModalRef;

  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any;
    associatedUsers?: any;
  };

  @Input()
  openProposal: any;

  /**
   * Separador a abrir logo que o formulário de edição carrega (ex.: a página
   * de angariação a apontar para o campo em falta). Aplica-se depois do
   * `modal(content)`, como o `openProposal` — antes disso o `openModal`
   * repõe o separador 1. Consome-se uma vez: gravar e reabrir volta ao 1.
   */
  @Input()
  openTab: number | null = null;

  propertyReviewData: any;

  user!: User;

  showApprovedAlert = false;
  private approvedAlertTimer?: any;
  minimumCommissionValidation: {
    active: boolean;
    minimum: number | null;
    action: "BLOCK_SAVE" | "SEND_TO_MASTER_VALIDATION";
  } | null = null;

  // AI doc wizard
  /** True when the AI doc-extraction service is activated for this entity (eligibility). */
  showWizard = false;
  /** Whether the user has dismissed the AI suggestion banner this session. */
  aiBannerDismissed = false;
  /** Whether the wizard overlay is currently open. */
  aiWizardOpen = false;
  /** Codes of AI services activated for this entity (loaded on modal open) */
  private aiActivatedCodes: string[] = [];
  canViewAiIntegrations = false;
  /** Extração de documentos ativa para este utilizador (imóvel novo ou existente). */
  aiExtractionAvailable = false;
  aiPanelOpen = false;
  /** Desmonta os separadores enquanto os valores aceites são aplicados. */
  aiRemountingTabs = false;
  aiLookups: AiLookups | null = null;
  aiCurrentValues: AiCurrentValues | null = null;
  aiPanelPropertyFileIds: number[] = [];
  /** Referências vivas aos dados dos separadores, para os badges "IA". */
  readonly aiProvenanceSources: AiProvenanceSources = Object.defineProperties(
    {},
    {
      details: { get: () => this.detailsForm },
      address: { get: () => this.addressForm },
      areasNearby: { get: () => this.propertyAreasNearbyData },
    },
  );

  constructor(
    private eventService: EventService,
    private modalService: NgbModal,
    private propertiesService: PropertiesService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
    public authService: AuthService,
    public permissionsService: PermissionsService,
    private proposalsService: ProposalsService,
    private propertyData: PropertyDataService,
    private propertyValidationService: PropertyValidationRulesService,
    private notificationService: NotificationService,
    private cookiesService: CookieService,
    private aiIntegrationsService: AiIntegrationsService,
    private contactsService: ContactsService,
    private filesService: FilesService,
    private aiExtractionState: AiExtractionStateService,
    private aiUsageLink: AiUsageLinkStateService,
    private propertyExtraction: PropertyExtractionService,
    private activityLogsService: ActivityLogsService,
  ) {
    this.currentNavTabSubject = new BehaviorSubject<number>(this.nabTabActive);
    this.subscription = new Subscription();
    this.user = this.authService?.currentUserValue;
    this.permissionsService.user = this.user;
  }

  ngOnInit(): void {
    // Histórico: abrir a ficha para edição é uma visita (uma por abertura).
    if (this.property?.id) {
      this.activityLogsService.trackPropertyEvent(this.property.id, {
        action: "PROPERTY_VIEW",
        navigationId: this.activityLogsService.newNavigationId(),
        context: "edit",
      });
    }

    const updateProposalsSub = this.eventService.subscribe(
      "update-proposals",
      (data) => (this.propertyProposalsData = data),
    );
    const canChangeSub = this.eventService.subscribe(
      "can-change-business-status",
      (value) => (this.canChangeBusinessStatus = value),
    );

    const subAddExistContact = this.eventService.subscribe(
      "add-exist-contact",
      (data: any) => {
        if (!data?.contacts?.length) return;

        if (data?.kind === "owners") {
          const owners = data.contacts ?? [];

          this.propertyOwnersContactsData.data.owners = owners;
          this.propertyOwnersContactsData.data.total = owners.length;

          this.refreshOwnersWarning();

          this.checkWarning();

          this.cdr.detectChanges();
        }
      },
    );

    // O separador CMI usa o componente partilhado app-mediation-contract, que
    // publica o seu estado no PropertyDataService. Os avisos do CMI calculam-se
    // aqui, a partir desse canal, para não ser preciso tocar no partilhado.
    const cmiSub = this.propertyData.cmiFormData$.subscribe(() => {
      this.refreshCmiWarnings();
      this.checkWarning();
    });

    this.subscription.add(subAddExistContact);
    this.subscriptions.add(updateProposalsSub);
    this.subscriptions.add(canChangeSub);
    this.subscriptions.add(cmiSub);
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.loadJs();

    const { id, role, stores, associatedUsers } =
      this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };
    this.canViewAiIntegrations = this.permissionsService.hasPermission(
      "VIEW_AI_INTEGRATIONS",
    );
    this.getStatus();
    this.activeId = this.dataToFormInitAdvertisement?.activeId;

    if (!this.property) {
      // New property: use effective activation status (entity/store/user) to
      // decide whether the AI wizard should be available for this user.
      if (!this.canViewAiIntegrations) {
        this.aiActivatedCodes = [];
        this.openModal(this.property, this.content);
      } else {
        this.aiIntegrationsService
          .getServicesWithStatus()
          .pipe(take(1))
          .subscribe({
            next: (services) => {
              this.aiActivatedCodes = (services ?? [])
                .filter((service: any) => service?.activated)
                .map((service: any) =>
                  String(service?.code ?? "").toUpperCase(),
                );
              this.aiExtractionAvailable = this.aiActivatedCodes.includes(
                "DOC_INTELLIGENCE_PROPERTY",
              );
            },
            error: () => {
              this.aiActivatedCodes = [];
              this.aiExtractionAvailable = false;
            },
          })
          .add(() => this.openModal(this.property, this.content));
      }
    } else {
      this.openModal(this.property, this.content);
      // Depois de o formulário abrir, e sem o atrasar: só quem tem a permissão
      // de IA pergunta se a extração de documentos está ativa.
      this.loadAiExtractionAvailability();
    }

    if (!this.subscriptionDataTabAgents)
      this.subscriptionDataTabAgents = this.eventService.subscribe(
        "data-tab-agents",
        (data) => {
          if (!this.modalClosed) {
            this.propertyAgentsData = data;
            this.dataToFormInitAgentsDetails = data;
          }
        },
      );

    //get regions by country
    const subscriptionRegions = this.eventService.subscribe(
      "get-data-address-regions",
      (data) => {
        this.propertiesService
          .getDataForAddressRegions(data.cid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-regions", data);
          });
      },
    );
    this.subscriptions.add(subscriptionRegions);

    //get districts by region
    const subscriptionDistricts = this.eventService.subscribe(
      "get-data-address-districts",
      (data) => {
        this.propertiesService
          .getDataForAddressDistrict(data.rid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-districts", data);
          });
      },
    );
    this.subscriptions.add(subscriptionDistricts);

    //get counties by district
    const subscriptionCounties = this.eventService.subscribe(
      "get-data-address-counties",
      (data) => {
        this.propertiesService
          .getDataForAddressCounties(data.did)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-counties", data);
          });
      },
    );
    this.subscriptions.add(subscriptionCounties);

    //get parishes by county
    const subscriptionParishes = this.eventService.subscribe(
      "get-data-address-parishes",
      (data) => {
        this.propertiesService
          .getDataForAddressParish(data.cid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-parishes", data);
          });
      },
    );

    this.subscriptions.add(subscriptionParishes);

    const subscriptionCheckW = this.eventService.subscribe(
      "check-warning-add-property",
      (data) => {
        this.checkWarning();
      },
    );

    this.subscriptions.add(subscriptionCheckW);

    const subscriptionPropertyTypeChanged = this.eventService.subscribe(
      "property-type-changed",
      () => {
        if (this.propertyAreasNearbyData) {
          this.propertyAreasNearbyData.errors = this.createAreasErrors(
            this.propertyAreasNearbyData?.data,
          );
          this.propertyAreasNearbyData.valid =
            this.propertyAreasNearbyData.errors.length > 0 ? false : true;
        }
        this.checkWarning();
      },
    );

    this.subscriptions.add(subscriptionPropertyTypeChanged);

    this.subscriptionCkeckWarning = this.eventService.subscribe(
      "store-data-to-form-init-agents",
      (data) => {
        this.dataToFormInitAgents = data;

        let agentMaain = this.dataToFormInitAgents?.find(
          (a: any) => a.id === this.propertiesService.getUserAuth().id,
        );
        if (this.isStoreOperatorAgent(agentMaain)) {
          agentMaain = null;
        }

        if (this.propertiesService.getUserAuth().role?.name === "MASTER") {
          agentMaain = this.dataToFormInitAgents.find((a1: any) =>
            this.propertyAgentsData?.find(
              (a2: any) => a2.id === a1.id && a2.isMain === true,
            ),
          );
          if (this.isStoreOperatorAgent(agentMaain)) {
            agentMaain = null;
          }
        }

        if (agentMaain) {
          this.propertyAgentsData = this.dataToFormInitAgents.filter(
            (a1: any) =>
              a1.id !== agentMaain.id &&
              this.propertyAgentsData?.find((a2: any) => a2.id === a1.id),
          );

          if (this.propertyAgentsData.length > 0) {
            this.propertyAgentsData.push({
              ...agentMaain,
              add: true,
              isMain: true,
              isListingAgent: true,
            });
          } else
            this.propertyAgentsData = [
              { ...agentMaain, add: true, isMain: true, isListingAgent: true },
            ];
        } else this.propertyAgentsData = [];

        this.eventService.broadcast("set-store-data-to-form-init-agents", {
          propertyAgentsData: this.propertyAgentsData,
        });
        this.cdr.detectChanges();
      },
    );

    const subscriptionchangeTabAddProperty = this.eventService.subscribe(
      "change-tab-add-property",
      (data) => {
        this.nabTabActive = data;
        this.currentNavTabSubject.next(this.nabTabActive);
        this.cdr.detectChanges();
      },
    );

    this.subscriptions.add(subscriptionchangeTabAddProperty);
  }

  initForms(property: any) {
    if (property) {
      this.detailsForm = {
        data: { ...property.details },
        errors: [],
        valid: true,
      };
      this.detailsForm.errors = this.createDetailsErrors(property);
      this.detailsForm.valid == this.detailsForm.errors.length > 0
        ? false
        : true;

      this.addressForm = {
        data: { ...property.address },
        errors: [],
        valid: true,
      };
      this.addressForm.errors = this.createAddressErrors(property);
      this.addressForm.valid =
        this.addressForm.errors.length > 0 ? false : true;

      this.propertyAreasNearbyData = {
        data: { ...property.areasNearby },
        errors: [],
        valid: true,
      };

      this.propertyAreasNearbyData.errors = this.createAreasErrors(
        this.propertyAreasNearbyData?.data,
      );
      this.propertyAreasNearbyData.valid =
        this.propertyAreasNearbyData.errors.length > 0 ? false : true;

      this.propertyCharateristicsData = {
        data: { ...property.characteristics },
        errors: [],
        valid: true,
      };

      this.propertyAdvertisementData = {
        data: { ...property.Advertisement },
        errors: [],
        valid: true,
      };
      this.propertyAdvertisementData.errors =
        this.createAdvertisementErrors(property);
      this.propertyAdvertisementData.valid =
        this.propertyAdvertisementData.errors.length > 0 ? false : true;

      this.propertyMultimediaData = {
        data: property.multimedia,
        dataDeleteImages: [],
        dataDeleteVideos: [],
        errors: [],
      };

      this.propertyMultimediaData.errors = this.buildMultimediaErrors(
        this.propertyMultimediaData.data,
      );

      this.propertyAgentsData = property.propertyAgents;
      setTimeout(() => {
        this.dataToFormInitAgentsDetails = this.propertyAgentsData;
        this.cdr.detectChanges();
      }, 100);

      this.propertyCostumersContactsData = {
        data: property.propertyCostumersContacts,
        dataDelete: [],
      };

      this.propertyOwnersContactsData = {
        data: property.propertyOwnersContacts,
        errors: [],
        valid: true,
        dataDelete: [],
      };

      this.refreshOwnersWarning();

      this.propertyDocumentsData = {
        data: property.documents,
        dataUpload: [],
        dataDeletefiles: [],
      };

      this.propertyDocumentsData.errors = this.buildDocumentsErrors(
        this.propertyDocumentsData.data,
      );

      this.refreshCmiWarnings();

      this.propertyPortalsData = { ...property?.portals };
      this.propertyProposalsData = property?.proposals;

      this.propertyReviewData = property.review;
    } else {
      // New property: show AI wizard only if the service is activated for this entity
      this.showWizard =
        this.canViewAiIntegrations &&
        this.aiActivatedCodes.includes("DOC_INTELLIGENCE_PROPERTY");

      const storeMain = this.dataToFormInitDetails?.stores.find(
        (s: any) => s.isMain === true,
      );

      this.detailsForm = { data: {}, errors: [], valid: false };
      this.detailsForm.data.store = storeMain?.id;
      this.detailsForm.errors = this.createDetailsErrors(property);
      this.detailsForm.valid == this.detailsForm.errors.length > 0
        ? false
        : true;

      this.refreshCmiWarnings();

      let c;
      let r;
      let d;
      let co;
      let p;
      if (storeMain?.countryId) {
        c = this.dataToFormInitAddress.countries.find(
          (c: any) => c.id === storeMain?.countryId,
        );
        r = c.regions.find((c: any) => c.id === storeMain?.district?.regionId);
        d = r.districts.find((c: any) => c.id === storeMain?.districtId);
        co = d.counties.find((c: any) => c.name === "---");
        p = co.parishs.find((c: any) => c.name === "---");
        if (!c) {
          c = this.dataToFormInitAddress.countries.find(
            (c: any) => c.name === "---",
          );
          r = c.regions.find((c: any) => c.name === "---");
          d = r.districts.find((c: any) => c.name === "---");
          co = d.counties.find((c: any) => c.name === "---");
          p = co.parishs.find((c: any) => c.name === "---");
        } else if (!r) {
          r = c.regions.find((c: any) => c.name === "---");
          d = r.districts.find((c: any) => c.name === "---");
          co = d.counties.find((c: any) => c.name === "---");
          p = co.parishs.find((c: any) => c.name === "---");
        }
      } else {
        c = this.dataToFormInitAddress.countries.find(
          (c: any) => c.name === "---",
        );
        r = c.regions.find((c: any) => c.name === "---");
        d = r.districts.find((c: any) => c.name === "---");
        co = d.counties.find((c: any) => c.name === "---");
        p = co.parishs.find((c: any) => c.name === "---");
      }

      this.dataToFormInitAddress.regions = c.regions;
      this.dataToFormInitAddress.districts = r.districts;
      this.dataToFormInitAddress.counties = d.counties;
      this.dataToFormInitAddress.parishes = co.parishs;

      this.addressForm = {
        data: {},
        errors: [],
        valid: true,
      };

      this.addressForm.data = {
        country: c.id,
        countryName: c.name,
        region: r.id,
        regionName: r.name,
        district: d.id,
        districtName: d.name,
        county: co.id,
        countyName: co.name,
        parish: p.id,
        parishName: p.name,
        latitude: this.dataToFormInitAddress.latitude,
        longitude: this.dataToFormInitAddress.longitude,
      };
      if (storeMain?.countryId) {
        this.addressForm.errors = this.createAddressErrors(true);
      } else {
        this.addressForm.errors = this.createAddressErrors(property);
      }

      this.addressForm.valid =
        this.addressForm.errors.length > 0 ? false : true;

      this.propertyAreasNearbyData = {
        data: {},
        errors: [],
        valid: true,
        detailsForm: this.detailsForm,
      };

      this.propertyAreasNearbyData.errors = this.createAreasErrors(property);
      this.propertyAreasNearbyData.valid =
        this.propertyAreasNearbyData.errors.length > 0 ? false : true;

      this.propertyCharateristicsData = { data: {}, errors: [], valid: true };
      this.propertyAdvertisementData = { data: {}, errors: [], valid: false };
      for (let lang of this.dataToFormInitAdvertisement?.langs) {
        this.propertyAdvertisementData.data[`lang${lang.id}_title`] = "N/A";
      }

      if (this.dataToFormInitAdvertisement?.langs?.length > 0) {
        this.propertyAdvertisementData.errors =
          this.createAdvertisementErrors(property);
        this.propertyAdvertisementData.valid =
          this.propertyAdvertisementData.errors.length > 0 ? false : true;
        this.propertyAdvertisementData.data[
          `lang${this.dataToFormInitAdvertisement.langs[0].id}_main`
        ] = true;
      }

      this.propertyMultimediaData = {
        data: { images: [], videos: [] },
        dataDeleteImages: [],
        dataDeleteVideos: [],
        errors: [],
      };

      this.propertyMultimediaData.errors = this.buildMultimediaErrors(
        this.propertyMultimediaData.data,
      );

      this.propertyOwnersContactsData = {
        data: { owners: [], total: 0 },
        errors: [],
        valid: true,
        dataDelete: [],
      };

      this.refreshOwnersWarning();

      let agentMaain = this.dataToFormInitAgents?.find(
        (a: any) => a.id === this.propertiesService.getUserAuth().id,
      );
      if (this.isStoreOperatorAgent(agentMaain)) {
        agentMaain = null;
      }

      // fix bug
      this.dataToFormInitAgents?.forEach((d: any) => {
        d.add = false;
        d.isMain = false;
        d.isListingAgent = false;
      });

      if (agentMaain) {
        this.propertyAgentsData = [
          { ...agentMaain, add: true, isMain: true, isListingAgent: true },
        ];
      } else this.propertyAgentsData = [];

      this.propertyCostumersContactsData = {
        data: { costumers: [], total: 0 },
        dataDelete: [],
      };
      this.propertyOwnersContactsData = {
        data: { owners: [], total: 0 },
        dataDelete: [],
      };

      this.propertyDocumentsData = {
        data: [],
        dataUpload: [],
        dataDeletefiles: [],
      };

      this.propertyDocumentsData.errors = this.buildDocumentsErrors(
        this.propertyDocumentsData.data,
      );

      this.propertyPortalsData = {
        data: [],
        externalPortals: [],
        portalsLogs: [],
        aux: this.dataToFormInitPortals?.portals,
      };

      for (let p of this.dataToFormInitPortals.portals) {
        this.propertyPortalsData.data[`portal${p.id}`] =
          p.activateOnAllProperties;
      }
    }

    this.checkWarning();

    // Monitora mudanças em qualquer form para revalidar o status.
    // UM único observer partilhado, guardado para ser desligado: a versão
    // anterior criava 6 observers em document.body por inicialização e nunca
    // chamava disconnect() — cada um forçava um tick global de change
    // detection por mutação de DOM (em microtask), acumulando entre aberturas
    // até congelar o browser.
    clearTimeout(this.formWatchTimeout);
    this.formWatchTimeout = setTimeout(() => {
      const formsToWatch = [
        this.detailsForm,
        this.addressForm,
        this.propertyAreasNearbyData,
        this.propertyCharateristicsData,
        this.propertyAdvertisementData,
        this.propertyOwnersContactsData,
      ];

      this.disconnectFormWatchObserver();
      if (formsToWatch.some((form) => form?.data)) {
        // Observa SÓ o modal do formulário, nunca o document.body: com a
        // ficha aberta por cima da página de um negócio, mutações contínuas
        // da página por trás (ex.: um *ngFor sem referência estável no
        // histórico) realimentavam checkWarning() → tick → nova mutação →
        // checkWarning(), em ciclo, até congelar o browser.
        const target = document.querySelector(".modal-create-properties");
        if (!target) return;
        this.formWatchObserver = new MutationObserver(() => {
          this.checkWarning();
        });
        this.formWatchObserver.observe(target, {
          childList: true,
          subtree: true,
        });
      }
    }, 300);
  }

  private disconnectFormWatchObserver(): void {
    if (this.formWatchObserver) {
      this.formWatchObserver.disconnect();
      this.formWatchObserver = null;
    }
  }

  getStatus() {
    this.proposalsService.getStatus().subscribe((status: any[]) => {
      this.statusList = status;
    });
  }
  // ---------------------------------------------------------------------------
  // Extração de documentos com IA (serviço DOC_INTELLIGENCE_PROPERTY)
  //
  // Tudo aqui é inerte sem o serviço ativo: `aiExtractionAvailable` fica a
  // false, o painel nunca abre e nenhum pedido é feito.
  // ---------------------------------------------------------------------------

  private plainAiValue(value: any): any {
    // Antes da primeira alteração, os separadores guardam `[valor, validadores]`.
    return Array.isArray(value) ? value[0] : value;
  }

  private plainAiData(data: any): Record<string, any> {
    const plain: Record<string, any> = {};
    for (const key of Object.keys(data ?? {})) {
      plain[key] = this.plainAiValue(data[key]);
    }
    return plain;
  }

  private buildAiLookups(): AiLookups {
    const simple = (list: any[]) =>
      (list ?? [])
        .filter((item: any) => item?.id && `${item?.description ?? ""}`.trim() !== "---")
        .map((item: any) => ({
          id: Number(item.id),
          label: `${item.description ?? item.name ?? ""}`,
          group: item.groupDescription ?? null,
        }));

    const characteristics: AiLookups["characteristics"] = [];
    for (const group of this.dataToFormInitChar?.characteristics ?? []) {
      for (const char of group?.char ?? []) {
        characteristics.push({
          id: Number(char.id),
          label: `${char.description ?? ""}`,
          group: `${group.description ?? ""}`,
          groupId: Number(group.id),
        });
      }
    }

    return {
      propertyTypes: simple(this.dataToFormInitDetails?.propertyTypes),
      conditions: simple(this.dataToFormInitDetails?.conditions),
      energyClasses: simple(this.dataToFormInitDetails?.ec),
      divisions: (this.dataToFormInitAreasNearby?.divisions ?? []).map((item: any) => ({
        id: Number(item?.division?.id),
        label: `${item?.division?.description ?? ""}`,
      })),
      nearby: (this.dataToFormInitAreasNearby?.nearby ?? []).map((item: any) => ({
        id: Number(item?.nearby?.id),
        label: `${item?.nearby?.description ?? ""}`,
      })),
      units: (this.dataToFormInitAreasNearby?.units ?? []).map((item: any) => ({
        id: Number(item?.id),
        label: `${item?.shortDescription ?? item?.description ?? ""}`,
      })),
      characteristics,
    };
  }

  /**
   * Imóvel existente: descobre, em segundo plano, se a extração de documentos
   * está ativa para o utilizador. Nunca atrasa nem condiciona a abertura do
   * formulário, e sem a permissão de IA não faz pedido nenhum.
   */
  private loadAiExtractionAvailability() {
    if (!this.canViewAiIntegrations) return;

    this.aiIntegrationsService
      .getServicesWithStatus()
      .pipe(take(1))
      .subscribe({
        next: (services) => {
          this.aiExtractionAvailable = (services ?? []).some(
            (service: any) =>
              service?.activated &&
              String(service?.code ?? "").toUpperCase() ===
                "DOC_INTELLIGENCE_PROPERTY",
          );
          this.loadAiProvenance();
        },
        error: () => {
          this.aiExtractionAvailable = false;
        },
      });
  }

  /** Proveniência guardada de um imóvel existente, para os badges "IA". */
  private loadAiProvenance() {
    const propertyId = this.property?.id;
    if (!this.aiExtractionAvailable || !propertyId) return;

    this.propertyExtraction
      .getProvenance(propertyId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const fields: AiFieldProvenance[] = [];
          for (const field of response?.fields ?? []) {
            const base = {
              documentName: field.documentName,
              page: field.page,
              confidence: field.confidence,
            };
            if (field.kind === "FIELD" && field.form?.control) {
              const raw = field.value?.value;
              const value =
                field.form.control === "yearOfConstruction" && raw
                  ? new Date(`${raw}-01-01T00:00:00`)
                  : raw;
              fields.push({
                tab: field.form.tab,
                control: field.form.control,
                value,
                ...base,
              });
            } else if (field.kind === "DIVISION" && field.value?.divisionId) {
              fields.push({
                tab: "areasNearby",
                control: `division${field.value.divisionId}`,
                value: field.value.count,
                ...base,
              });
            }
          }
          this.aiExtractionState.setProvenance(fields);
        },
        error: () => undefined,
      });
  }

  /**
   * Abre o painel de extração. `propertyFileIds` vem do separador Documentos,
   * para analisar documentos que já estão guardados no imóvel.
   */
  openAiPanel(propertyFileIds: number[] = []) {
    if (!this.aiExtractionAvailable) return;

    // Os separadores montados passam o que têm no formulário para os dados
    // partilhados, para a revisão comparar com os valores atuais.
    this.eventService.broadcast("get-data-tab-details");
    this.eventService.broadcast("get-data-tab-address");
    this.eventService.broadcast("get-data-tab-areas-nearby");
    this.eventService.broadcast("get-data-tab-charateristics");

    this.aiLookups = this.buildAiLookups();
    this.aiCurrentValues = {
      details: this.plainAiData(this.detailsForm?.data),
      address: this.plainAiData(this.addressForm?.data),
      areasNearby: this.plainAiData(this.propertyAreasNearbyData?.data),
    };
    this.aiPanelPropertyFileIds = Array.isArray(propertyFileIds)
      ? propertyFileIds
      : [];
    this.aiPanelOpen = true;
    this.aiBannerDismissed = true;
    this.cdr.detectChanges();
  }

  closeAiPanel() {
    this.aiPanelOpen = false;
    this.cdr.detectChanges();
  }

  /**
   * Aplica ao formulário o que foi aceite na revisão.
   *
   * Os separadores são desmontados antes de escrever: ao sair, cada um passa o
   * seu formulário para os dados partilhados, e ao voltar constrói-se a partir
   * deles já com os valores novos. Assim nenhum separador precisa de saber
   * aplicar valores de IA.
   */
  onAiExtractionApplied(patch: AiFormPatch) {
    this.aiPanelOpen = false;
    this.aiRemountingTabs = true;
    this.cdr.detectChanges();

    try {
      this.applyAiFormPatch(patch);
      this.applyAiOwners(patch.owners);
      this.aiExtractionState.mergeProvenance(patch.provenance);
    } finally {
      this.aiRemountingTabs = false;
    }

    this.checkWarning();
    this.cdr.detectChanges();

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: this.translate.instant("ai-extraction.applied.title", {
        count: patch.appliedKeys.length,
      }),
      text: this.translate.instant("ai-extraction.applied.text"),
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  }

  private applyAiFormPatch(patch: AiFormPatch) {
    this.detailsForm = this.detailsForm ?? { data: {}, errors: [], valid: false };
    this.detailsForm.data = this.plainAiData(this.detailsForm.data);
    this.addressForm = this.addressForm ?? { data: {}, errors: [], valid: false };
    this.addressForm.data = this.plainAiData(this.addressForm.data);
    this.propertyAreasNearbyData = this.propertyAreasNearbyData ?? {
      data: {},
      errors: [],
      valid: false,
    };
    this.propertyAreasNearbyData.data = this.plainAiData(
      this.propertyAreasNearbyData.data,
    );

    for (const key of Object.keys(patch.details ?? {})) {
      this.detailsForm.data[key] = patch.details[key];
    }

    const address = patch.address ?? {};
    for (const key of Object.keys(address)) {
      this.addressForm.data[key] = address[key];
    }
    if (address.district) {
      // Atualiza também as listas dependentes quando a árvore já está
      // carregada, para o separador Morada abrir com as opções certas.
      this.tryApplyLocationByIds({
        locationMatch: {
          district: { id: address.district, name: address.districtName },
          county: address.county
            ? { id: address.county, name: address.countyName }
            : null,
          parish: address.parish
            ? { id: address.parish, name: address.parishName }
            : null,
        },
      } as any);
      // `tryApplyLocationByIds` pode repor níveis que não encontrou na árvore.
      for (const key of Object.keys(address)) {
        this.addressForm.data[key] = address[key];
      }
    }

    const areas = this.propertyAreasNearbyData.data;
    for (const key of Object.keys(patch.areas ?? {})) {
      areas[key] = patch.areas[key];
    }

    for (const division of patch.divisions ?? []) {
      const count = Math.floor(Number(division.count));
      if (!division.divisionId || !Number.isFinite(count) || count <= 0) continue;

      const current = Number(this.plainAiValue(areas[`division${division.divisionId}`]) ?? 0);
      // Divisões só acrescentam: nunca reduzem o que o utilizador já tinha.
      const total = Math.max(count, Number.isFinite(current) ? current : 0);
      areas[`division${division.divisionId}`] = total;

      /**
       * A gravação conta as divisões pelas chaves `areaInput-{id}-{n}`
       * (a começar em 1). Sem elas a contagem chegava ao servidor como 0.
       * Com áreas discriminadas, cada linha recebe a sua; com uma área única,
       * só a primeira a recebe (replicá-la inventaria área).
       */
      for (let index = 1; index <= total; index++) {
        const key = `areaInput-${division.divisionId}-${index}`;
        const existing = Number(this.plainAiValue(areas[key]));
        if (Number.isFinite(existing) && existing > 0) continue;

        const individual = division.individualAreas?.[index - 1];
        if (Number.isFinite(individual as number) && Number(individual) > 0) {
          areas[key] = Number(individual);
          continue;
        }
        const single =
          index === 1 &&
          !division.individualAreas?.length &&
          Number.isFinite(division.area as number) &&
          Number(division.area) > 0;
        areas[key] = single ? Number(division.area) : 0;
      }
    }

    for (const nearby of patch.nearby ?? []) {
      // Sem unidade a gravação do imóvel falha.
      if (!nearby.nearbyId || !nearby.unitId) continue;
      areas[`nearby${nearby.nearbyId}`] = true;
      areas[`unitNearBy-${nearby.nearbyId}`] = nearby.unitId;
      areas[`valNearby-${nearby.nearbyId}`] =
        Number.isFinite(nearby.distance as number) && Number(nearby.distance) > 0
          ? Number(nearby.distance)
          : 0;
    }

    if (patch.characteristics?.length) {
      this.propertyCharateristicsData = this.propertyCharateristicsData ?? {
        data: {},
        errors: [],
        valid: true,
      };
      this.propertyCharateristicsData.data = this.plainAiData(
        this.propertyCharateristicsData.data,
      );
      for (const characteristic of patch.characteristics) {
        if (!characteristic.groupId || !characteristic.characteristicId) continue;
        this.propertyCharateristicsData.data[
          `p${characteristic.groupId}_char${characteristic.characteristicId}`
        ] = true;
      }
    }

    this.propertyData.updateTab("details", this.detailsForm.data);
    this.propertyData.updateTab("address", this.addressForm.data);
    this.propertyData.updateTab("areasNearby", this.propertyAreasNearbyData.data);
  }

  /**
   * Proprietários aceites na revisão. Um contacto que já existe é associado;
   * os restantes ficam como candidatos e são criados ao gravar o imóvel.
   */
  private applyAiOwners(owners: AiFormPatch["owners"]) {
    if (!Array.isArray(owners) || !owners.length) return;

    const linked = owners.filter((owner) => !!owner.contactId);
    const created = owners.filter((owner) => !owner.contactId);

    if (created.length) this.mergeOwnerCandidatesFromExtraction(created);
    if (!linked.length) return;

    this.propertyOwnersContactsData = this.propertyOwnersContactsData ?? {
      data: { owners: [], total: 0 },
      errors: [],
      valid: true,
      dataDelete: [],
    };
    this.propertyOwnersContactsData.data = this.propertyOwnersContactsData.data ?? {
      owners: [],
      total: 0,
    };
    const list: any[] = (this.propertyOwnersContactsData.data.owners =
      this.propertyOwnersContactsData.data.owners ?? []);

    for (const owner of linked) {
      const exists = list.some(
        (current: any) => Number(current?.id) === Number(owner.contactId),
      );
      if (exists) continue;
      const [firstName, lastName] = this.splitOwnerName(owner.name);
      const phone = this.normalizeOwnerPhone(owner.phone);
      list.unshift({
        id: owner.contactId,
        firstName,
        lastName,
        email: owner.email || null,
        phoneNumber1: phone || null,
        phone: phone || null,
        address: owner.address || null,
        fiscalIdentification: owner.fiscalIdentification || null,
        status: true,
        isSelected: false,
        isAddToProperty: true,
        isNew: false,
      });
    }

    this.propertyOwnersContactsData.data.total = list.length;
    this.refreshOwnersWarning();
  }

  // AI Doc Wizard
  /** Opens the wizard as an overlay (triggered from the dismissable banner). */
  openAiWizard() {
    if (!this.canViewAiIntegrations) return;
    this.aiWizardOpen = true;
    this.aiBannerDismissed = true;
    this.cdr.detectChanges();
  }

  /** Dismisses the AI suggestion banner without opening the wizard. */
  dismissAiBanner() {
    this.aiBannerDismissed = true;
    this.cdr.detectChanges();
  }

  /** Closes the wizard overlay (e.g. user clicked the close button). */
  closeAiWizard() {
    this.aiWizardOpen = false;
    this.cdr.detectChanges();
  }

  onWizardSkip() {
    this.aiWizardOpen = false;
    this.aiBannerDismissed = true;
    this.cdr.detectChanges();
  }

  onWizardExtracted(data: DocExtractionResult | Record<string, any>) {
    const normalizedData: DocExtractionResult =
      this.normalizeAiDocExtractionPayload(data);
    const extractedDocs = Array.isArray((data as any)?.__aiDocuments)
      ? ((data as any).__aiDocuments as Array<{
        code: string;
        label: string;
        file: File;
      }>)
      : [];

    this.aiWizardOpen = false;
    this.aiBannerDismissed = true;

    this.applyExtractionToParentForms(normalizedData);
    this.attachAiDocumentsToProperty(extractedDocs);

    // Broadcast so child forms update
    this.eventService.broadcast("ai-doc-extracted", normalizedData);
    this.eventService.broadcast("get-data-tab-documents");
    this.checkWarning();
    this.cdr.detectChanges();
  }

  private normalizeAiDocExtractionPayload(
    data: DocExtractionResult | Record<string, any>,
  ): DocExtractionResult {
    const payload = (data ?? {}) as any;
    const extraction = payload?.extraction ?? payload;
    const structured = payload?.structured ?? extraction?.structured ?? {};
    const form = payload?.form ?? extraction?.form ?? structured?.form ?? {};
    const details = form?.details ?? {};
    const address = form?.address ?? structured?.address ?? {};
    const areas = form?.areasNearby ?? structured?.areas ?? {};
    const rooms = form?.rooms ?? structured?.rooms ?? {};
    const legal = structured?.legal ?? {};
    const financial = structured?.financial ?? {};
    const energy = structured?.energy ?? {};
    const contacts = form?.contacts ?? structured?.contacts ?? {};

    return {
      ...extraction,
      propertyType: this.firstAiValue(
        details.propertyType,
        extraction.propertyType,
        extraction.typology,
      ),
      condition: this.firstAiValue(details.condition, extraction.condition),
      yearOfConstruction: this.firstAiValue(
        details.yearOfConstruction,
        extraction.yearOfConstruction,
      ),
      ecCode: this.firstAiValue(
        details.ecCode,
        extraction.ecCode,
        energy.classCode,
      ),
      ecNumber: this.firstAiValue(
        details.ecNumber,
        extraction.ecNumber,
        energy.certificateNumber,
      ),
      ecExpirationDate: this.firstAiValue(
        details.ecExpirationDate,
        extraction.ecExpirationDate,
        energy.validityDate,
      ),
      renewableEnergy: this.firstAiValue(
        details.renewableEnergy,
        extraction.renewableEnergy,
        energy.renewableEnergy,
      ),
      carbonEmissions: this.firstAiValue(
        details.carbonEmissions,
        extraction.carbonEmissions,
        energy.carbonEmissions,
        energy.co2Emissions,
      ),
      useLicense: this.firstAiValue(
        details.useLicense,
        extraction.useLicense,
        legal.usageLicenseNumber,
      ),
      buildingLicense: this.firstAiValue(
        details.buildingLicense,
        extraction.buildingLicense,
        legal.buildingLicenseNumber,
      ),
      dateLicense: this.firstAiValue(
        details.dateLicense,
        extraction.dateLicense,
        legal.usageLicenseDate,
      ),
      technicalSheetLicense: this.firstAiValue(
        details.technicalSheetLicense,
        extraction.technicalSheetLicense,
        legal.technicalSheetNumber,
      ),
      propertyValue: this.firstAiValue(
        details.propertyValue,
        extraction.propertyValue,
        financial.taxAssetValue,
      ),
      price: this.firstAiValue(
        details.price,
        extraction.price,
        financial.askingPrice,
      ),
      address: this.firstAiValue(address.address, extraction.address),
      zipCode: this.firstAiValue(address.zipCode, extraction.zipCode),
      doorNumber: this.firstAiValue(address.doorNumber, extraction.doorNumber),
      floor: this.firstAiValue(address.floor, extraction.floor),
      fraction: this.firstAiValue(address.fraction, extraction.fraction),
      districtName: this.firstAiValue(
        address.districtName,
        extraction.districtName,
      ),
      countyName: this.firstAiValue(address.countyName, extraction.countyName),
      parishName: this.firstAiValue(address.parishName, extraction.parishName),
      latitude: this.firstAiValue(address.latitude, extraction.latitude),
      longitude: this.firstAiValue(address.longitude, extraction.longitude),
      usefulArea: this.firstAiValue(areas.usefulArea, extraction.usefulArea),
      grossArea: this.firstAiValue(areas.grossArea, extraction.grossArea),
      grossPrivateArea: this.firstAiValue(
        areas.grossPrivateArea,
        extraction.grossPrivateArea,
      ),
      grossDependentArea: this.firstAiValue(
        areas.grossDependentArea,
        extraction.grossDependentArea,
      ),
      landArea: this.firstAiValue(areas.landArea, extraction.landArea),
      buildingImplantationArea: this.firstAiValue(
        areas.buildingImplantationArea,
        extraction.buildingImplantationArea,
      ),
      rooms: this.firstAiValue(rooms.rooms, extraction.rooms),
      bathrooms: this.firstAiValue(rooms.bathrooms, extraction.bathrooms),
      livingRooms: this.firstAiValue(
        rooms.livingRooms,
        extraction.livingRooms,
      ),
      offices: this.firstAiValue(rooms.offices, extraction.offices),
      parkingSpots: this.firstAiValue(
        rooms.parkingSpots,
        extraction.parkingSpots,
      ),
      suites: this.firstAiValue(rooms.suites, extraction.suites),
      divisions: extraction.divisions ?? structured.divisions,
      proximities: extraction.proximities ?? structured.proximities,
      characteristics:
        extraction.characteristics ?? structured.characteristics ?? [],
      owners: extraction.owners ?? contacts.owners ?? [],
      artigo: this.firstAiValue(
        extraction.artigo,
        legal.matrixArticle,
        legal.landRegistryNumber,
      ),
      locationMatch: payload.locationMatch ?? extraction.locationMatch,
      structured,
      form,
      quality: payload.quality ?? structured.quality,
      evidence: payload.evidence ?? structured.evidence,
      documentsProcessed:
        payload.documentsProcessed ?? extraction.documentsProcessed,
      confidence: this.firstAiValue(payload.confidence, extraction.confidence),
    };
  }

  private firstAiValue(...values: any[]) {
    return values.find((value) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    });
  }

  private applyExtractionToParentForms(data: DocExtractionResult) {
    if (!data) return;

    this.detailsForm = this.detailsForm ?? { data: {} };
    this.detailsForm.data = this.detailsForm.data ?? {};
    this.addressForm = this.addressForm ?? { data: {} };
    this.addressForm.data = this.addressForm.data ?? {};
    this.propertyAreasNearbyData = this.propertyAreasNearbyData ?? { data: {} };
    this.propertyAreasNearbyData.data = this.propertyAreasNearbyData.data ?? {};

    if (data.yearOfConstruction) {
      this.detailsForm.data.yearOfConstruction = new Date(
        `${data.yearOfConstruction}-01-01`,
      );
    }

    if ((data as any)?.ecNumber) {
      this.detailsForm.data.ecNumber = (data as any).ecNumber;
    }
    if ((data as any)?.ecExpirationDate) {
      this.detailsForm.data.ecExpirationDate = this.coerceAiDate(
        (data as any).ecExpirationDate,
      );
    }
    if ((data as any)?.renewableEnergy !== undefined) {
      this.detailsForm.data.renewableEnergy = (data as any).renewableEnergy;
    }
    if ((data as any)?.carbonEmissions !== undefined) {
      this.detailsForm.data.carbonEmissions = (data as any).carbonEmissions;
    }
    if ((data as any)?.useLicense) {
      this.detailsForm.data.useLicense = (data as any).useLicense;
    }
    if ((data as any)?.buildingLicense) {
      this.detailsForm.data.buildingLicense = (data as any).buildingLicense;
    }
    if ((data as any)?.dateLicense) {
      this.detailsForm.data.dateLicense = this.coerceAiDate(
        (data as any).dateLicense,
      );
    }
    if ((data as any)?.technicalSheetLicense) {
      this.detailsForm.data.technicalSheetLicense = (
        data as any
      ).technicalSheetLicense;
    }
    if ((data as any)?.propertyValue !== undefined) {
      this.detailsForm.data.propertyValue = (data as any).propertyValue;
    }
    if ((data as any)?.price !== undefined && !this.detailsForm.data.price) {
      this.detailsForm.data.price = (data as any).price;
    }

    if ((data as any)?.ecCode) {
      const ecId = this.resolveOptionIdByText(
        this.dataToFormInitDetails?.ec,
        (data as any).ecCode,
      );
      if (ecId) this.detailsForm.data.ec = ecId;
    }

    const propertyTypeText = (data as any)?.propertyType ?? data.typology;
    if (propertyTypeText) {
      const propertyTypeId = this.resolveOptionIdByText(
        this.dataToFormInitDetails?.propertyTypes,
        propertyTypeText,
      );
      if (propertyTypeId) this.detailsForm.data.propertyType = propertyTypeId;
    }

    if ((data as any)?.condition) {
      const conditionId = this.resolveOptionIdByText(
        this.dataToFormInitDetails?.conditions,
        (data as any).condition,
      );
      if (conditionId) this.detailsForm.data.condition = conditionId;
    }

    if (data.address) this.addressForm.data.address = data.address;
    if (data.zipCode) this.addressForm.data.zipCode = data.zipCode;
    if ((data as any)?.doorNumber)
      this.addressForm.data.doorNumber = (data as any).doorNumber;
    if (data.fraction) this.addressForm.data.fraction = data.fraction;
    if (data.floor) this.addressForm.data.floor = data.floor;
    const extractedDistrictName = this.resolveExtractionLocationName(
      data,
      "district",
    );
    const extractedCountyName = this.resolveExtractionLocationName(
      data,
      "county",
    );
    const extractedParishName = this.resolveExtractionLocationName(
      data,
      "parish",
    );
    if (extractedDistrictName)
      this.addressForm.data.districtName = extractedDistrictName;
    if (extractedCountyName)
      this.addressForm.data.countyName = extractedCountyName;
    if (extractedParishName)
      this.addressForm.data.parishName = extractedParishName;
    if ((data as any)?.latitude)
      this.addressForm.data.latitude = String((data as any).latitude);
    if ((data as any)?.longitude)
      this.addressForm.data.longitude = String((data as any).longitude);

    if (data.usefulArea)
      this.propertyAreasNearbyData.data.usefulArea = data.usefulArea;
    if (data.grossArea)
      this.propertyAreasNearbyData.data.grossArea = data.grossArea;
    if (data.grossPrivateArea)
      this.propertyAreasNearbyData.data.grossPrivateArea =
        data.grossPrivateArea;
    if (data.grossDependentArea)
      this.propertyAreasNearbyData.data.grossDependentArea =
        data.grossDependentArea;
    if ((data as any)?.landArea)
      this.propertyAreasNearbyData.data.landArea = (data as any).landArea;
    if ((data as any)?.buildingImplantationArea) {
      this.propertyAreasNearbyData.data.buildingImplantationArea = (
        data as any
      ).buildingImplantationArea;
    }
    this.applyDivisionCountToAreaData("rooms", (data as any)?.rooms, [
      "quarto",
      "bedroom",
      "room",
    ]);
    this.applyDivisionCountToAreaData("bathrooms", (data as any)?.bathrooms, [
      "casa de banho",
      "wc",
      "banho",
      "bath",
    ]);
    this.applyDivisionCountToAreaData(
      "livingRooms",
      (data as any)?.livingRooms,
      ["sala", "salas", "living room", "lounge"],
    );
    this.applyDivisionCountToAreaData("offices", (data as any)?.offices, [
      "escritorio",
      "office",
      "gabinete",
    ]);
    this.applyDivisionCountToAreaData("suites", (data as any)?.suites, [
      "suite",
      "suíte",
    ]);
    this.applyDivisionCountToAreaData(
      "parkingSpots",
      (data as any)?.parkingSpots,
      ["garagem", "estacionamento", "parking", "lugar"],
    );
    this.applyDivisionDetailsFromExtraction((data as any)?.divisions);
    this.applyProximitiesFromExtraction((data as any)?.proximities);
    this.applyCharacteristicsFromExtraction((data as any)?.characteristics);
    this.mergeOwnerCandidatesFromExtraction((data as any)?.owners);

    this._matchLocation(data);
    this.propertyData.updateTab("details", this.detailsForm.data);
    this.propertyData.updateTab("address", this.addressForm.data);
    this.propertyData.updateTab(
      "areasNearby",
      this.propertyAreasNearbyData.data,
    );
    this.propertyData.updateTab("contacts", {
      owners: this.propertyOwnersContactsData?.data?.owners ?? [],
      customers: this.propertyCostumersContactsData?.data?.costumers ?? [],
    });

    this.detailsForm.errors = this.createDetailsErrors(this.property);
    this.detailsForm.valid = this.detailsForm.errors.length === 0;
    this.addressForm.errors = this.createAddressErrors(this.property);
    this.addressForm.valid = this.addressForm.errors.length === 0;
    this.propertyAreasNearbyData.errors = this.createAreasErrors(
      this.property,
    );
    this.propertyAreasNearbyData.valid =
      this.propertyAreasNearbyData.errors.length === 0;
  }

  private coerceAiDate(value: any): any {
    if (!value) return value;
    if (value instanceof Date) return value;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date;
  }

  private resolveOptionIdByText(list: any[], value: any): number | undefined {
    if (!Array.isArray(list) || value === null || value === undefined)
      return undefined;
    const wanted = this.normalizeLocationText(value);
    if (!wanted) return undefined;

    const direct = list.find((item: any) => {
      const desc = this.normalizeLocationText(item?.description);
      const name = this.normalizeLocationText(item?.name);
      const key = this.normalizeLocationText(item?.key);
      return desc === wanted || name === wanted || key === wanted;
    });
    if (direct?.id) return Number(direct.id);

    const fuzzy = list.find((item: any) => {
      const desc = this.normalizeLocationText(item?.description);
      const name = this.normalizeLocationText(item?.name);
      return (
        (desc && (desc.includes(wanted) || wanted.includes(desc))) ||
        (name && (name.includes(wanted) || wanted.includes(name)))
      );
    });
    if (fuzzy?.id) return Number(fuzzy.id);
    return undefined;
  }

  private applyDivisionCountToAreaData(
    _field: string,
    value: any,
    keywords: string[],
  ) {
    const count = Number(value);
    if (!Number.isFinite(count) || count <= 0) return;

    const divisionId = this.resolveDivisionIdByKeywords(keywords);
    if (!divisionId) return;

    this.propertyAreasNearbyData.data[`division${divisionId}`] =
      Math.floor(count);
  }

  private applyDivisionDetailsFromExtraction(divisions: any) {
    if (!Array.isArray(divisions)) return;
    for (const item of divisions) {
      const label = this.normalizeLocationText(item?.label ?? item?.name);
      if (!label) continue;
      const divisionId = this.resolveDivisionIdByKeywords([label]);
      if (!divisionId) continue;

      const count = Number(item?.count);
      if (Number.isFinite(count) && count > 0) {
        this.propertyAreasNearbyData.data[`division${divisionId}`] =
          Math.floor(count);
      }
    }
  }

  private applyProximitiesFromExtraction(proximities: any) {
    if (!Array.isArray(proximities) || !this.dataToFormInitAreasNearby) return;
    const nearbyEntries = this.dataToFormInitAreasNearby?.nearby ?? [];
    const units = this.dataToFormInitAreasNearby?.units ?? [];

    for (const item of proximities) {
      const label = this.normalizeLocationText(item?.label ?? item?.name);
      if (!label) continue;
      const nearby = nearbyEntries.find((entry: any) => {
        const text = this.normalizeLocationText(
          entry?.description ?? entry?.nearby?.description,
        );
        return text && (text.includes(label) || label.includes(text));
      });
      const nearbyId = Number(nearby?.nearby?.id ?? 0);
      if (!nearbyId) continue;

      this.propertyAreasNearbyData.data[`nearby${nearbyId}`] = true;

      const distance = Number(item?.distance);
      if (Number.isFinite(distance) && distance > 0) {
        this.propertyAreasNearbyData.data[`valNearby-${nearbyId}`] = distance;
      }

      const unitText = this.normalizeLocationText(item?.unit);
      if (unitText) {
        const unit = units.find((entry: any) => {
          const text = this.normalizeLocationText(entry?.description);
          return text && (text.includes(unitText) || unitText.includes(text));
        });
        if (unit?.id)
          this.propertyAreasNearbyData.data[`unitNearBy-${nearbyId}`] = unit.id;
      }
    }
  }

  private applyCharacteristicsFromExtraction(characteristics: any) {
    if (!Array.isArray(characteristics) || !characteristics.length) return;
    this.propertyCharateristicsData = this.propertyCharateristicsData ?? {
      data: {},
    };
    this.propertyCharateristicsData.data =
      this.propertyCharateristicsData.data ?? {};

    const normalizedTargets = characteristics
      .map((value) => this.normalizeLocationText(value))
      .filter((value: string) => !!value);
    if (!normalizedTargets.length) return;

    for (const group of this.dataToFormInitChar?.characteristics ?? []) {
      for (const char of group?.char ?? []) {
        const charLabel = this.normalizeLocationText(char?.description);
        if (!charLabel) continue;
        const matched = normalizedTargets.some(
          (target) => charLabel.includes(target) || target.includes(charLabel),
        );
        if (!matched) continue;
        this.propertyCharateristicsData.data[`p${group.id}_char${char.id}`] =
          true;
      }
    }
  }

  private mergeOwnerCandidatesFromExtraction(ownersRaw: any) {
    if (!Array.isArray(ownersRaw) || !ownersRaw.length) return;
    this.propertyOwnersContactsData = this.propertyOwnersContactsData ?? {
      data: { owners: [], total: 0 },
      errors: [],
      valid: true,
      dataDelete: [],
    };
    this.propertyOwnersContactsData.data = this.propertyOwnersContactsData
      .data ?? {
      owners: [],
      total: 0,
    };
    this.propertyOwnersContactsData.data.owners =
      this.propertyOwnersContactsData.data.owners ?? [];

    for (const owner of ownersRaw) {
      const fullName = String(owner?.name ?? "").trim();
      if (!fullName) continue;
      const [firstName, lastName] = this.splitOwnerName(fullName);
      const fiscalIdentification = String(
        owner?.fiscalIdentification ?? "",
      ).trim();
      const email = String(owner?.email ?? "").trim();
      const phone = this.normalizeOwnerPhone(owner?.phone);
      const address = String(owner?.address ?? "").trim();

      const exists = this.propertyOwnersContactsData.data.owners.some(
        (current: any) => {
          const currentFiscal = String(
            current?.fiscalIdentification ?? "",
          ).trim();
          const currentEmail = String(current?.email ?? "")
            .trim()
            .toLowerCase();
          const currentPhone = this.normalizeOwnerPhone(
            current?.phoneNumber1 ?? current?.phoneNumber ?? current?.phone,
          );
          const currentName =
            `${String(current?.firstName ?? "").trim()} ${String(current?.lastName ?? "").trim()}`
              .trim()
              .toLowerCase();
          const candidateName = `${firstName} ${lastName}`.trim().toLowerCase();

          return (
            (!!fiscalIdentification &&
              currentFiscal === fiscalIdentification) ||
            (!!email && currentEmail === email.toLowerCase()) ||
            (!!phone && currentPhone === phone) ||
            (!!candidateName && currentName === candidateName)
          );
        },
      );
      if (exists) continue;

      this.propertyOwnersContactsData.data.owners.unshift({
        id: null,
        firstName,
        lastName,
        email: email || null,
        phoneNumber1: phone || null,
        phone: phone || null,
        address: address || null,
        fiscalIdentification: fiscalIdentification || null,
        status: true,
        isSelected: false,
        isAddToProperty: true,
        isNew: true,
        __aiOwnerCandidate: true,
      });
    }

    this.propertyOwnersContactsData.data.total =
      this.propertyOwnersContactsData.data.owners.length;
    this.refreshOwnersWarning();
  }

  private splitOwnerName(name: string): [string, string] {
    const normalized = String(name ?? "")
      .trim()
      .replace(/\s+/g, " ");
    if (!normalized) return ["", ""];
    const parts = normalized.split(" ");
    if (parts.length === 1) return [parts[0], parts[0]];
    const lastName = parts.pop() as string;
    return [parts.join(" "), lastName];
  }

  private normalizeOwnerPhone(value: any): string {
    return String(value ?? "")
      .replace(/[^\d+]/g, "")
      .trim();
  }

  private async resolveDefaultContactSourceId(): Promise<number | null> {
    try {
      const response: any = await this.contactsService
        .getContactsTypes()
        .toPromise();
      const sources = Array.isArray(response)
        ? response
        : Array.isArray(response?.sources)
          ? response.sources
          : [];
      if (!sources.length) return null;

      const active = sources.filter(
        (item: any) => item?.status !== false && item?.isActive !== false,
      );
      const pool = active.length ? active : sources;
      const preferred =
        pool.find((item: any) => item?.isDefault === true) ??
        pool.find((item: any) => {
          const label = this.normalizeLocationText(
            item?.name ?? item?.description ?? item?.translateKey,
          );
          return label.includes("owner") || label.includes("propriet");
        }) ??
        pool[0];
      const id = Number(preferred?.id ?? 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    } catch {
      return null;
    }
  }

  private async ensureOwnersPersistedForSave(): Promise<boolean> {
    const owners = this.propertyOwnersContactsData?.data?.owners ?? [];
    if (!owners.length) return true;

    const hasPendingOwners = owners.some((owner: any) => {
      const ownerId = Number(owner?.id ?? 0);
      return !Number.isFinite(ownerId) || ownerId <= 0;
    });
    if (!hasPendingOwners) return true;

    const sourceId = await this.resolveDefaultContactSourceId();

    for (let index = 0; index < owners.length; index++) {
      const owner = owners[index];
      const ownerId = Number(owner?.id ?? 0);
      if (Number.isFinite(ownerId) && ownerId > 0) continue;

      const firstName = String(owner?.firstName ?? "").trim();
      const lastName = String(owner?.lastName ?? "").trim();
      if (!firstName || !lastName) continue;

      const formData = new FormData();
      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      if (sourceId) {
        formData.append("contactType", `${sourceId}`);
      }
      formData.append("status", "true");

      const email = String(owner?.email ?? "").trim();
      const phoneNumber1 = this.normalizeOwnerPhone(
        owner?.phoneNumber1 ?? owner?.phoneNumber ?? owner?.phone,
      );
      const address = String(owner?.address ?? "").trim();
      const fiscalIdentification = String(
        owner?.fiscalIdentification ?? "",
      ).trim();

      if (email) formData.append("email", email);
      if (phoneNumber1) formData.append("phoneNumber1", phoneNumber1);
      if (address) formData.append("address", address);
      if (fiscalIdentification)
        formData.append("fiscalIdentification", fiscalIdentification);

      try {
        const created = await this.contactsService
          .createOwners(formData, { returnContact: true })
          .toPromise();
        if (created?.id) {
          owners[index] = {
            ...created,
            isSelected: false,
            isAddToProperty: true,
            isNew: true,
          };
        }
      } catch {
        continue;
      }
    }

    this.propertyOwnersContactsData.data.owners = owners;
    this.propertyOwnersContactsData.data.total = owners.length;
    this.refreshOwnersWarning();

    const hasUnresolvedOwners = owners.some((owner: any) => {
      const ownerId = Number(owner?.id ?? 0);
      return !Number.isFinite(ownerId) || ownerId <= 0;
    });
    return !hasUnresolvedOwners;
  }

  private resolveDivisionIdByKeywords(keywords: string[]): number | undefined {
    const divisions = this.dataToFormInitAreasNearby?.divisions ?? [];
    for (const entry of divisions) {
      const label = this.normalizeLocationText(
        entry?.description ?? entry?.division?.description,
      );
      if (!label) continue;
      const matched = keywords.some((keyword) =>
        label.includes(this.normalizeLocationText(keyword)),
      );
      if (matched) {
        const id = Number(entry?.division?.id ?? 0);
        if (id > 0) return id;
      }
    }
    return undefined;
  }

  private attachAiDocumentsToProperty(
    docs: Array<{ code: string; label: string; file: File }>,
  ) {
    if (!Array.isArray(docs) || !docs.length) return;
    if (!this.propertyDocumentsData) {
      this.propertyDocumentsData = {
        data: [],
        dataUpload: [],
        dataDeletefiles: [],
        errors: [],
      };
    }
    this.propertyDocumentsData.data = this.propertyDocumentsData.data ?? [];
    this.propertyDocumentsData.dataUpload =
      this.propertyDocumentsData.dataUpload ?? [];

    for (const item of docs) {
      if (!(item?.file instanceof File)) continue;
      const exists = this.propertyDocumentsData.data.some(
        (doc: any) =>
          String(doc?.name ?? "").toLowerCase() ===
          String(item.file.name ?? "").toLowerCase() &&
          Number(doc?.size ?? 0) === Number(item.file.size ?? 0),
      );
      if (exists) continue;

      this.propertyDocumentsData.data.unshift({
        name: item.file.name,
        size: item.file.size,
        type: item.file.type || "application/octet-stream",
        createdAt: new Date(),
        isNew: true,
        description: "---",
        order: this.propertyDocumentsData.data.length + 1,
      });
      this.propertyDocumentsData.dataUpload.unshift(item.file);
    }

    this.recalculateDocumentOrder();
    this.propertyDocumentsData.errors = this.buildDocumentsErrors(
      this.propertyDocumentsData.data,
    );
  }

  private recalculateDocumentOrder() {
    if (!Array.isArray(this.propertyDocumentsData?.data)) return;
    let order = this.propertyDocumentsData.data.length;
    for (const doc of this.propertyDocumentsData.data) {
      doc.order = order;
      order--;
    }
  }

  private _matchLocation(data: DocExtractionResult) {
    if (!this.dataToFormInitAddress?.countries) return;
    const countries = this.dataToFormInitAddress.countries;

    const matchedById = this.tryApplyLocationByIds(data);
    if (matchedById) return;

    const wantedDistrict = this.normalizeLocationText(
      this.resolveExtractionLocationName(data, "district"),
    );
    const wantedCounty = this.normalizeLocationText(
      this.resolveExtractionLocationName(data, "county"),
    );
    const wantedParish = this.normalizeLocationText(
      this.resolveExtractionLocationName(data, "parish"),
    );

    let best: {
      score: number;
      country: any;
      region: any;
      district: any;
      county: any;
      parish: any;
    } | null = null;

    for (const country of countries) {
      for (const region of country.regions ?? []) {
        for (const district of region.districts ?? []) {
          const districtScore = wantedDistrict
            ? this.scoreLocationMatch(
              this.normalizeLocationText(district?.name),
              wantedDistrict,
            )
            : wantedCounty || wantedParish
              ? 30
              : 0;
          if (districtScore <= 0) continue;
          for (const county of district.counties ?? []) {
            const countyScore = wantedCounty
              ? this.scoreLocationMatch(
                this.normalizeLocationText(county?.name),
                wantedCounty,
              )
              : wantedParish
                ? 10
                : 0;
            if (wantedCounty && countyScore <= 0) continue;
            for (const parish of county.parishs ?? []) {
              const parishScore = wantedParish
                ? this.scoreLocationMatch(
                  this.normalizeLocationText(parish?.name),
                  wantedParish,
                )
                : 0;
              if (wantedParish && parishScore <= 0) continue;

              const score = districtScore + countyScore + parishScore;
              if (!best || score > best.score) {
                best = { score, country, region, district, county, parish };
              }
            }
          }
        }
      }
    }

    if (!best) return;
    this.applyMatchedLocation(
      best.country,
      best.region,
      best.district,
      best.county,
      best.parish,
    );
  }

  private resolveExtractionLocationName(
    data: DocExtractionResult,
    kind: "district" | "county" | "parish",
  ): string | undefined {
    const key = `${kind}Name`;
    const topLevel = (data as any)?.[key];
    const nestedAddress = (data as any)?.address?.[key];
    const fromMatch = (data as any)?.locationMatch?.[kind]?.name;

    const candidate = [topLevel, nestedAddress, fromMatch].find((value) => {
      if (value === null || value === undefined) return false;
      return String(value).trim().length > 0;
    });

    return candidate ? String(candidate) : undefined;
  }

  private tryApplyLocationByIds(data: DocExtractionResult): boolean {
    const locationMatch = (data as any)?.locationMatch;
    if (!locationMatch) return false;

    const wantedDistrictId = Number(locationMatch?.district?.id || 0);
    const wantedCountyId = Number(locationMatch?.county?.id || 0);
    const wantedParishId = Number(locationMatch?.parish?.id || 0);
    if (!wantedDistrictId) return false;

    for (const country of this.dataToFormInitAddress?.countries ?? []) {
      for (const region of country.regions ?? []) {
        const district = (region.districts ?? []).find(
          (item: any) => item?.id === wantedDistrictId,
        );
        if (!district) continue;
        const county = wantedCountyId
          ? (district.counties ?? []).find(
            (item: any) => item?.id === wantedCountyId,
          )
          : undefined;
        const parish =
          wantedParishId && county
            ? (county.parishs ?? []).find(
              (item: any) => item?.id === wantedParishId,
            )
            : undefined;
        this.applyMatchedLocation(country, region, district, county, parish);
        return true;
      }
    }

    return false;
  }

  private applyMatchedLocation(
    country: any,
    region: any,
    district: any,
    county?: any,
    parish?: any,
  ) {
    const resolvedCounty =
      county ??
      (district?.counties ?? []).find((item: any) => item?.name === "---") ??
      (district?.counties ?? [])[0];
    const resolvedParish =
      parish ??
      (resolvedCounty?.parishs ?? []).find(
        (item: any) => item?.name === "---",
      ) ??
      (resolvedCounty?.parishs ?? [])[0];
    if (!resolvedCounty || !resolvedParish) return;

    this.addressForm.data.country = country.id;
    this.addressForm.data.region = region.id;
    this.addressForm.data.district = district.id;
    this.addressForm.data.districtName = district.name;
    this.addressForm.data.county = resolvedCounty.id;
    this.addressForm.data.countyName = resolvedCounty.name;
    this.addressForm.data.parish = resolvedParish.id;
    this.addressForm.data.parishName = resolvedParish.name;

    this.dataToFormInitAddress.regions = country.regions;
    this.dataToFormInitAddress.districts = region.districts;
    this.dataToFormInitAddress.counties = district.counties;
    this.dataToFormInitAddress.parishes = resolvedCounty.parishs;
  }

  private normalizeLocationText(value: any): string {
    return String(value ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,/\\-]/g, " ")
      .replace(/\b(de|da|do|das|dos|e)\b/gi, " ")
      .replace(/\s+/g, " ")
      .toLowerCase()
      .trim();
  }

  private scoreLocationMatch(candidate: string, wanted: string): number {
    if (!candidate || !wanted) return 0;
    if (candidate === wanted) return 100;
    if (candidate.includes(wanted) || wanted.includes(candidate)) return 85;

    const candidateTokens = candidate.split(" ").filter(Boolean);
    const wantedTokens = wanted.split(" ").filter(Boolean);
    if (!candidateTokens.length || !wantedTokens.length) return 0;

    const matches = wantedTokens.filter((token) =>
      candidateTokens.includes(token),
    ).length;
    const ratio =
      matches / Math.max(wantedTokens.length, candidateTokens.length);
    return Math.round(ratio * 75);
  }

  private countWarnFields(errors?: any[]): number {
    if (!Array.isArray(errors)) return 0;

    return errors.filter((e: any) => !!e?.type?.warning || !!e?.type?.required)
      .length;
  }

  private hasWarn(errors?: any[]): boolean {
    return this.countWarnFields(errors) > 0;
  }

  checkWarning() {
    if (this.modalClosed) return;

    this.refreshMinimumCommissionValidationOnChange();

    // Ficha base: tabs "de campos" (1 por warning) + contactos (binário).
    let base = 0;
    base += this.countWarnFields(this.detailsForm?.errors);
    base += this.countWarnFields(this.addressForm?.errors);
    base += this.countWarnFields(this.propertyAreasNearbyData?.errors);
    base += this.countWarnFields(this.propertyAdvertisementData?.errors);

    this.refreshOwnersWarning();
    if (this.hasWarn(this.propertyOwnersContactsData?.errors)) {
      base++;
    }

    // Total: a ficha base mais o CMI, multimédia, documentos e a ativação.
    let val = base;
    val += this.countWarnFields(this.propertyCmiData?.errors);

    if (this.hasWarn(this.propertyMultimediaData?.errors)) val++;
    if (this.hasWarn(this.propertyDocumentsData?.errors)) val++;

    if (!this.canActivateProperties?.available && !this.propertyUpdate?.status)
      val++;

    this.baseWarningSubject$.next(base);
    this.warningSubject$.next(val);

    const errordetailsForm = (this.detailsForm?.errors ?? []).filter(
      (e: any) => {
        if (e?.key === "dealId") {
          return false;
        }

        return (
          e?.type?.required || (e?.key === "reference" && e?.type?.warning)
        );
      },
    );

    this.requiredSubject$.next(errordetailsForm.length > 0);
  }

  private refreshMinimumCommissionValidationOnChange() {
    const dataProp = this.detailsForm?.data;
    if (!dataProp) {
      this.minimumCommissionValidation = null;
      return;
    }

    if (
      this.isRentBusinessTypeOnFront(dataProp) ||
      this.isMinimumCommissionApprovedForProperty(dataProp)
    ) {
      this.minimumCommissionValidation = null;
      return;
    }

    const commissionsConfig = this.dataToFormInitDetails?.commissions;
    const action = commissionsConfig?.minimumCommissionViolationAction;
    const minimum = Number(
      `${commissionsConfig?.minimumSaleCommission ?? 0}`
        .replace(/\s/g, "")
        .replace(",", "."),
    );

    if (
      !["BLOCK_SAVE", "SEND_TO_MASTER_VALIDATION"].includes(action) ||
      !Number.isFinite(minimum) ||
      minimum <= 0
    ) {
      this.minimumCommissionValidation = null;
      return;
    }

    const commissionRaw = `${dataProp?.saleCommission ?? ""}`.trim();
    if (!commissionRaw) {
      this.minimumCommissionValidation = null;
      return;
    }

    const commission = this.getCommissionPercentForMinimumRule(dataProp);

    if (!Number.isFinite(commission) || commission >= minimum) {
      this.minimumCommissionValidation = null;
      return;
    }

    this.minimumCommissionValidation = {
      active: true,
      minimum,
      action,
    };
  }

  approveProperty() {
    if (!this.property?.id) return;

    this.propertiesService.approveProperty(this.property.id).subscribe({
      next: (updated) => {
        this.property = updated;
        this.propertyUpdate = updated;
        this.minimumCommissionValidation = null;

        if (this.detailsForm?.data) {
          this.detailsForm.data.minimumCommissionPendingValidation = false;
          this.detailsForm.data.minimumCommissionApproved = true;
        }

        this.eventService.broadcast("refresh-properties");

        this.showAlertSuccess(this.translate.instant("t-approved-property"));
        this.notifyPropertiesRealtime(this.property.id);

        this.maybeShowApprovedAlert();

        this.cdr.detectChanges();

        this.modalFef.dismiss();
      },
      error: () =>
        this.errorMsg(this.translate.instant("t-aprroved-property-error")),
    });
  }

  rejectProperty(message: string) {
    if (!this.property?.id) return;

    this.propertiesService.rejectProperty(this.property.id, message).subscribe({
      next: (updated) => {
        this.property = updated;
        this.propertyUpdate = updated;

        this.eventService.broadcast("refresh-properties");

        this.showAlertSuccess(this.translate.instant("t-property-rejected"));
        this.notifyPropertiesRealtime(this.property.id);

        this.cdr.detectChanges();

        this.modalFef.dismiss();
      },
      error: () => {
        this.errorMsg(this.translate.instant("t-property-rejection-error"));
      },
    });
  }

  openModal(propertyUpdate: PropertyModel, content: any) {
    // validation rules
    this.propertyValidationService.loadPropertyValidationRules().subscribe({
      next: () => {
        this.requiredOwner =
          this.propertyValidationService.isEnabled("contacts.owner");

        this.propertyId = undefined;
        this.submitted = false;
        this.minimumCommissionValidation = null;
        this.isUpdate = propertyUpdate ? true : false;

        this.modalClosed = false;
        this.nabTabActive = 1;
        this.activeIdChangeNabTab();

        if (propertyUpdate) {
          this.propertyId = propertyUpdate.id;
          this.propertyUpdate = propertyUpdate;
          this.textAddOrUpdateModalTitle = "t-edit-property";

          this.propertiesService
            .findOne(propertyUpdate.id)
            .subscribe({
              error: () => {
                this.errorMsg(this.translate.instant("t-error-updating"));
              },
              next: (data) => {
              if (this.propertyUpdate.id) {
                this.propertyUpdate = { ...data, id: propertyUpdate.id };
                if (this.property)
                  this.property.entity = this.propertyUpdate.entity;
                else this.property = this.propertyUpdate;
              }

              this.portalsLogs = data?.portalsLogs;
              this.canChangeBusinessStatus = data?.canChangeBusinessStatus;
              // Inicializa os forms das tabs
              this.initForms(data);
              // Injeta o snapshot completo no PropertyDataService
              this.propertyData.seedFromProperty(data);

              this.propertyData.seedFromCMI({
                contractNumber: data?.details?.contractNumber ?? null,
                startDateMediation: data?.details?.startDateMediation ?? null,
                endDateMediation: data?.details?.endDateMediation ?? null,
                autoRenewal: data?.details?.autoRenewal ?? null,
              });
              // Abre o modal depois de ter semeado os dados
              this.modal(content);

              // se vier da aba de propostas
              if (this.openProposal) {
                setTimeout(() => {
                  this.nabTabActive = 11;
                  this.activeIdChangeNabTab();
                }, 200);
              } else if (this.openTab) {
                const tab = this.openTab;
                this.openTab = null;
                setTimeout(() => {
                  this.nabTabActive = tab;
                  this.activeIdChangeNabTab();
                  this.cdr.detectChanges();
                }, 200);
              }
              },
            });
        } else {
          // criação de novo imóvel
          this.propertyUpdate = undefined;
          this.textAddOrUpdateModalTitle = "t-add-property";
          this.initForms(null);
          this.propertyData.resetPropertyFormData(); // limpa qualquer estado anterior
          this.modal(content);
        }
      },
      error: (err) => console.error(err),
    });
  }

  modal(content: any) {
    this.modalFef = this.modalService.open(content, {
      size: "xl",
      centered: true,
      scrollable: true,
      backdrop: "static",
      keyboard: false,
      modalDialogClass: "no-scroll-body",
      windowClass: "modal-create-properties",
    });

    this.modalFef.dismissed.subscribe(() => {
      this.resetForms();
      this.propertyData.resetPropertyFormData();
      this.modalClosed = true;
      this.submitted = false;
      this.openModaltSubject$.next(0);
      this.eventService.broadcast("is-open-modal-properties", false);
    });

    this.modalFef.closed.subscribe(() => {
      this.resetForms();
      this.propertyData.resetPropertyFormData();
      this.modalClosed = true;
      this.submitted = false;
      this.openModaltSubject$.next(0);
      this.eventService.broadcast("is-open-modal-properties", false);
    });
  }

  get currentProperty() {
    return this.propertyUpdate || this.property;
  }

  activeIdChangeNabTab() {
    this.currentNavTabSubject.next(this.nabTabActive);

    if (
      this.nabTabActive === 10 &&
      (this.propertyUpdate?.id || this.property?.id)
    ) {
      this.eventService.broadcast("documents-tab-active", {
        propertyId: this.propertyUpdate?.id || this.property?.id,
      });
    }
  }

  private hasRequiredDealMissing(): boolean {
    return this.detailsForm?.errors?.some(
      (error: any) =>
        error?.key === "dealId" &&
        (error?.type?.required || error?.type?.warning),
    );
  }

  private isRequiredDealApiError(error: any): boolean {
    const payload = JSON.stringify(error?.error ?? error ?? "").toLowerCase();
    return (
      payload.includes("dealid") &&
      (payload.includes("required") ||
        payload.includes("mandatory") ||
        payload.includes("obrigat"))
    );
  }

  private focusDetailsAndOpenSaleForm(): void {
    this.nabTabActive = 1;
    this.currentNavTabSubject.next(this.nabTabActive);

    setTimeout(() => {
      this.eventService.broadcast("open-sale-form-required-deal");
    }, 100);
  }

  private showRequiredDealWarningAndOpenSaleForm(): void {
    Swal.fire({
      title: this.translate.instant("t-property-required-deal-title"),
      text: this.translate.instant("t-property-required-deal-text"),
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-close"),
    }).then(() => {
      this.focusDetailsAndOpenSaleForm();
    });
  }

  async saveProperty(
    isBtnWarning = false,
    isValidate = false,
    generateRef = false,
  ) {
    // Fotos ainda a ser preparadas (uma de cada vez): gravar agora enviava
    // a lista incompleta.
    if (this.propertyMultimediaData?.preparingImages) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: this.translate.instant("t-preparing-images", {
          current: "…",
          total: "…",
        }),
        showConfirmButton: false,
        timer: 2500,
      });
      return;
    }
    this.submitted = true;
    this.minimumCommissionValidation = null;
    this.eventService.broadcast("get-data-tab-details");
    this.eventService.broadcast("get-data-tab-address");
    this.eventService.broadcast("get-data-tab-areas-nearby");
    this.eventService.broadcast("get-data-tab-charateristics");
    this.eventService.broadcast("get-data-tab-advertisement", {
      submitted: true,
    });
    this.eventService.broadcast("get-data-tab-agents");
    this.eventService.broadcast("get-data-tab-multimedia");
    this.eventService.broadcast("get-data-tab-contacts");
    this.eventService.broadcast("get-data-tab-portals");

    if (this.hasRequiredDealMissing()) {
      this.showRequiredDealWarningAndOpenSaleForm();
      return;
    }

    if (this.warningSubject$.getValue() > 0 && !isBtnWarning) {
      const btnShowtores = document.getElementById("btn-property-warning");
      if (btnShowtores) {
        btnShowtores.click();
      }
    } else {
      const btnCloseWarnning = document.getElementById("btn-warning-no");
      if (btnCloseWarnning) {
        btnCloseWarnning.click();
      }
      let dataProp: any = {};
      let divisions: any = [];
      let nearby: any = [];
      let advertisement: any = {};
      let agents: any = [];
      let videos: any = [];
      let deleteVideos: any = [];
      let imagesOrder: any = [];
      let docsAux: any = [];
      let portals: any = [];

      const keyDetailsForm = [
        "endDateMediation",
        "startDateMediation",
        "saleDate",
        "ecExpirationDate",
        "reference",
        "associatedProperty",
        "useLicense",
        "buildingLicense",
        "dateLicense",
        "technicalSheetLicense",
        "hideExclusive",
        "hidePrice",
        "hidePriceValue",
        "hideECNumber",
        "hideECExpirationDate",
        "hideUseLicense",
        "hideDateLicense",
        "hideTechnicalSheetLicense",
        "hideBuildingLicense",
        "yearOfConstruction",
        "partnerEntityName",
        "isPercentageCommission",
        "sharedSale",
        // Partilha interna: passam intactos (toNumericValue corrompe-os)
        "shareType",
        "partnerStoreId",
        "internalShareSellerId",
        "internalShareSellerCommission",
        "internalShareSeller",
        "hideRenewableEnergy",
        "hideCarbonEmissions",
        "exclusive",
        "methodPaymentCommission",
        "contractNumber",
        "paymentsConditions",
        "isTempReference",
        "keyNumber",
        "keyAddress",
        "hasPlate",
        "platePlacementDate",
        "plateRemovalDate",
        "internalObservations",
        "ecNumber",
      ];

      Object.entries(this.detailsForm?.data).forEach(([key, val]: any) => {
        const isVal = val
          ? `${val}`.trim().length !== 0
            ? true
            : false
          : false;
        if (keyDetailsForm.includes(key)) {
          dataProp[key] = val;
        } else if (!["defineEndDate", "type"].includes(key)) {
          const val1 = ["propertyType2"].includes(key)
            ? val
            : this.toNumericValue(val);
          dataProp[key] = val1;
        }
      });

      // Partilha interna: garante o payload do consultor vendedor mesmo que
      // o objeto sincronizado pelo sale-form ainda não exista no form.
      if (
        !dataProp["internalShareSeller"] &&
        dataProp["shareType"] === "internal" &&
        dataProp["internalShareSellerId"]
      ) {
        dataProp["internalShareSeller"] = {
          userId: dataProp["internalShareSellerId"],
          percentage: dataProp["internalShareSellerCommission"] ?? null,
        };
      }

      Object.entries(this.propertyData.currentCmiValue).forEach(
        ([key, val]: any) => {
          dataProp[key] = val;
        },
      );

      Object.entries(this.addressForm?.data).forEach(([key, val]: any) => {
        if (key == "latitude" || key == "longitude") {
          dataProp[key] = `${val}`;
        } else {
          dataProp[key] = val;
        }
        // }
      });

      const keyDivisionNearBy = [
        "usefulArea",
        "grossArea",
        "grossDependentArea",
        "grossPrivateArea",
        "landArea",
        "buildingImplantationArea",
        "hideBuildingImplantationArea",
        "hideGrossArea",
        "hideGrossDependentArea",
        "hideGrossPrivateArea",
        "hideLandArea",
        "hideUsefulArea",
      ];

      Object.entries(this.propertyAreasNearbyData?.data).forEach(
        ([key, val]: any) => {
          const isVal =
            val !== null || val !== undefined
              ? `${val}`.trim().length !== 0
                ? true
                : false
              : false;
          if (key.startsWith("division") && val) {
            const div = key.split("division");

            let count = 1;
            const areaInput = Object.entries(
              this.propertyAreasNearbyData?.data,
            ).filter(([key1, val1]: any) => {
              if (`areaInput-${div[1]}-${count}` === key1) {
                count++;
                return true;
              }
              return false;
            });

            const devisionList: any = [];
            areaInput.forEach((el: any) => {
              const o = el[0].split(`areaInput-${div[1]}-`)[1];
              const v = el[1];

              devisionList.push({ order: +o, val: v });
            });
            const statusDiv =
              this.propertyAreasNearbyData.data[`hideDivision${div[1]}`];
            divisions.push({
              id: +div[1],
              val: areaInput.length,
              hide: statusDiv,
              devisionList,
            });
          } else if (key.startsWith("nearby") && val) {
            const near = key.split("nearby");
            const valNearby = Object.entries(
              this.propertyAreasNearbyData?.data,
            ).filter(([key1, val1]: any) => {
              return `valNearby-${near[1]}` === key1;
            });

            const unitNearby = Object.entries(
              this.propertyAreasNearbyData?.data,
            ).filter(([key1, val1]: any) => {
              return `unitNearBy-${near[1]}` === key1;
            });
            const valN: any = valNearby[0][1];
            const statusNearBy =
              this.propertyAreasNearbyData.data[`hideNearby${near[1]}`];
            nearby.push({
              id: +near[1],
              val: +valN,
              unit: unitNearby[0][1],
              hide: statusNearBy,
            });
          } else if (isVal && keyDivisionNearBy.includes(key)) {
            const arrVal = [
              "hideBuildingImplantationArea",
              "hideGrossArea",
              "hideGrossDependentArea",
              "hideGrossPrivateArea",
              "hideLandArea",
              "hideUsefulArea",
            ];
            const val1 = arrVal.includes(key) ? val : this.toNumericValue(val);
            dataProp[key] = val1;
          }
        },
      );

      if (divisions.length > 0) {
        dataProp["divisions"] = divisions;
      }
      if (nearby.length > 0) {
        dataProp["nearby"] = nearby;
      }

      const characteristicsPayload = buildCharacteristicsPayload(
        this.propertyCharateristicsData?.data,
        this.dataToFormInitChar,
      );
      if (characteristicsPayload.ids.length > 0) {
        dataProp["charateristics"] = characteristicsPayload.ids;
      }
      // Formato com valor (quantidade / opção); o back-end dá-lhe prioridade.
      dataProp["characteristics"] = characteristicsPayload.items;

      Object.entries(this.propertyAdvertisementData?.data).forEach(
        ([key, val]: any) => {
          const isVal = val
            ? `${val}`.trim().length !== 0
              ? true
              : false
            : false;
          if (key.startsWith("lang") && key.endsWith("title") && isVal) {
            const k = key.split("_");
            const lg = k[0].split("lang");
            const langId = lg[1];

            if (!advertisement["langs"]) advertisement["langs"] = [];
            advertisement["langs"].push({
              lang: +langId,
              title: this.propertyAdvertisementData.data[`lang${langId}_title`],
              description:
                this.propertyAdvertisementData.data[
                `lang${langId}_description`
                ],
              isMain: this.propertyAdvertisementData.data[`lang${langId}_main`],
            });
          }
          if (key.startsWith("option") && val) {
            const op = key.split("option");
            if (!isBtnWarning || (isBtnWarning && op[1] != this.activeId)) {
              if (!advertisement["settings"]) advertisement["settings"] = [];
              advertisement["settings"].push(+op[1]);
            }
          }
        },
      );

      if (Object.entries(advertisement).length > 0) {
        dataProp["advertisement"] = advertisement;
      }

      agents = this.propertyAgentsData?.map((ag: any) => {
        return {
          id: ag.id,
          isMain: ag.isMain,
          isListingAgent: ag?.isListingAgent,
          isSellingAgent: !this.detailsForm?.data?.sharedSale
            ? ag?.isSellingAgent
            : false,
          listingCommission: ag?.isListingAgent
            ? ag?.listingCommission
            : undefined,
          saleCommission: ag?.isSellingAgent ? ag?.saleCommission : undefined,
        };
      });

      if (agents?.length > 0) {
        dataProp["agents"] = agents;
      }

      for (const video of this.propertyMultimediaData.data?.videos) {
        if (video.isNew)
          videos.push(video.link.changingThisBreaksApplicationSecurity);
      }
      if (videos.length > 0) {
        dataProp["videos"] = videos;
      }

      deleteVideos = this.propertyMultimediaData.dataDeleteVideos?.map(
        (v: any) => {
          return v.videoId;
        },
      );
      if (deleteVideos.length > 0) {
        dataProp["videosDelete"] = deleteVideos;
      }

      if (this.propertyMultimediaData?.data?.first) {
        dataProp["multimediaFirst"] = this.propertyMultimediaData?.data?.first;
      }

      for (const image of this.propertyMultimediaData.data.images) {
        // Recorte: só viaja quando foi mexido nesta sessão (`null` = repor
        // o automático); ausente = o servidor mantém o guardado.
        const cropFields = image.cropDirty ? { crop: image.crop ?? null } : {};
        if (image.isNew) {
          imagesOrder.push({
            order: image.id,
            name: `${image.name}${image.id}`,
            fileId: 0,
            description: image.caption,
            status: image.status,
            isAiGenerated: !!image.isAiGenerated,
            aiServiceCode: image.isAiGenerated ? image.aiServiceCode || "MANUAL" : null,
            ...cropFields,
          });
        } else {
          imagesOrder.push({
            order: image.id,
            name: `${image.name}${image.id}`,
            fileId: image.fileId,
            description: image.caption,
            status: image.status,
            isAiGenerated: !!image.isAiGenerated,
            aiServiceCode: image.isAiGenerated ? image.aiServiceCode || "MANUAL" : null,
            ...cropFields,
          });
        }
      }
      if (imagesOrder.length > 0) {
        dataProp["imagesOrder"] = imagesOrder;
      }

      if (
        this.propertyCostumersContactsData.data.costumers &&
        this.propertyCostumersContactsData.data.costumers.length > 0
      ) {
        dataProp["costumers"] =
          this.propertyCostumersContactsData.data.costumers.map(
            (c: any) => +c.id,
          );
      }
      const ownersPersisted = await this.ensureOwnersPersistedForSave();
      const hasOwnersToPersist =
        Array.isArray(this.propertyOwnersContactsData?.data?.owners) &&
        this.propertyOwnersContactsData.data.owners.length > 0;
      if (!ownersPersisted && hasOwnersToPersist) {
        this.errorMsg(this.translate.instant("t-required-owner"));
        this.isSave = false;
        return;
      }
      if (
        this.propertyOwnersContactsData.data.owners &&
        this.propertyOwnersContactsData.data.owners.length > 0
      ) {
        const ownerIds = this.propertyOwnersContactsData.data.owners
          .map((c: any) => Number(c?.id))
          .filter((id: number) => Number.isFinite(id) && id > 0);
        if (ownerIds.length > 0) {
          dataProp["owners"] = ownerIds;
        }
      }

      Object.entries(this.propertyPortalsData?.data).forEach(
        ([key, val]: any) => {
          const portal = key.split("portal")[1];
          const p = this.dataToFormInitPortals?.portals.find(
            (p: any) => p.id == portal,
          );
          if (Array.isArray(val)) {
            portals.push({ id: +portal, status: val[0], isep: p?.isep });
          } else {
            portals.push({ id: +portal, status: val, isep: p?.isep });
          }
        },
      );

      if (portals.length > 0) {
        dataProp["portals"] = portals;
      }

      for (const doc of this.propertyDocumentsData.data) {
        if (doc.isNew) {
          docsAux.push({
            fileId: 0,
            name: doc.name,
            description: doc.description,
            documentVisibility: doc.documentVisibility,
            showOnWebsite: doc.showOnWebsite,
            propertyDocumentTypeId: doc.propertyDocumentTypeId ?? null,
            order: doc.order,
          });
        } else {
          docsAux.push({
            fileId: doc.id,
            name: doc.name,
            description: doc.description,
            documentVisibility: doc.documentVisibility,
            showOnWebsite: doc.showOnWebsite,
            propertyDocumentTypeId: doc.propertyDocumentTypeId ?? null,
            order: doc.order,
          });
        }
      }

      if (docsAux.length > 0) {
        dataProp["docsAux"] = docsAux;
      }

      if (this.shouldBlockByMinimumCommissionOnFront(dataProp)) {
        return;
      }

      if (!this.isUpdate) {
        this.isSave = true;
        this.createProperty(
          { dataProp },
          isBtnWarning,
          isValidate,
          generateRef,
        );
      } else {
        this.isSave = true;
        this.updateProperty({ dataProp }, isValidate);
      }
    }
  }

  /**
   * Numeric coercion that also accepts comma as the decimal separator
   * (e.g. "3,5" → 3.5). Any other value behaves exactly like `+val`.
   */
  private toNumericValue(value: any): any {
    if (typeof value === "string" && value.includes(",")) {
      const parsed = +value.replace(/\s/g, "").replace(",", ".");
      return Number.isNaN(parsed) ? +value : parsed;
    }
    return +value;
  }

  /**
   * Create property
   */
  createProperty(
    data: any,
    isBtnWarning: boolean = false,
    isValidate = false,
    generateRef = false,
  ) {
    if (this.requiredSubject$.getValue() === false) {
      const dataValues = data?.dataProp;
      let formData: any = new FormData();

      formData.append("data", JSON.stringify(dataValues));
      // Imagens
      for (const image of this.propertyMultimediaData.data.images) {
        if (
          image.originalFile instanceof File ||
          image.originalFile instanceof Blob
        ) {
          formData.append(
            "images",
            this.renameFile(image.originalFile, `${image.name}${image.id}`),
          );
        } else {
          formData.append(
            "images",
            this.dataUrlToFile(image.img, `${image.name}${image.id}`),
          );
        }
      }
      // Documentos
      for (const doc of this.propertyDocumentsData.dataUpload) {
        formData.append("docs", doc);
      }
      // Criacao da propriedade
      this.propertiesService.createProperty(formData).subscribe(
        (data) => {
          if (data.create_property === "ref") {
            const msg = this.translate.instant(
              "t-m-properties.t-this-reference-has-already-been-used",
            );

            this.errorMsg(msg);
          } else {
            // Liga a extração de documentos revista ao imóvel acabado de criar.
            this.aiExtractionState.commit(data?.resId);
            // Liga os usos de IA feitos sem id (ex.: título grátis) ao imóvel.
            this.aiUsageLink.commit(data?.resId);
            if (isValidate === true && data.resId) {
              this.propertiesService.validateProperty(data.resId).subscribe({
                next: (updatedProperty) => {
                  this.property = updatedProperty;
                  this.propertyUpdate = updatedProperty;
                  this.isUpdate = true;

                  // Atualiza formulário
                  if (this.propertyForm instanceof FormGroup) {
                    this.propertyForm.patchValue({
                      businessStatus:
                        updatedProperty.propertyBusinessStatus?.id,
                    });
                  }

                  // Feedback visual
                  this.showAlertSuccess(
                    this.translate.instant("t-property-submitted"),
                  );

                  this.eventService.broadcast("refresh-properties");

                  if (data?.resId)
                    this.eventService.broadcast(
                      "new-property-created",
                      data.resId,
                    );

                  // Atualiza footer em tempo real
                  this.cdr.detectChanges();

                  // Fecha modal
                  this.modalFef.dismiss();
                },
                error: () =>
                  this.errorMsg(
                    this.translate.instant("t-property-validation-error"),
                  ),
              });
            } else {
              this.eventService.broadcast("refresh-properties");
              if (data?.resId)
                this.eventService.broadcast("new-property-created", data.resId);
              if (!generateRef) {
                this.modalFef.dismiss();
                const msg = this.translate.instant(
                  "t-m-properties.t-property-create-successfully",
                );

                this.showAlertSuccess(msg);
              } else {
                this.generateReferenceForCreated(data.resId);
              }
            }

            if (data?.minimumCommissionPendingValidation && data?.resId) {
              this.notifyPropertiesRealtime(data.resId);
              this.showAlertSuccess(
                this.translate.instant(
                  "t-property-minimum-commission-validation-sent",
                ),
              );
            }
          }

          this.isSave = false;

          if (
            data?.resId &&
            !isBtnWarning &&
            ![
              this.dataToFormInitDetails?.saleId,
              ...this.dataToFormInitDetails?.rentIds,
            ].includes(dataValues?.businessStatus)
          ) {
            this.eventService.broadcast("find-contacts-by-property", {
              propertyId: data.resId,
            });
          }
        },
        (error) => {
          this.eventService.broadcast("get-data-tab-details");
          if (this.handleMinimumCommissionBlockedError(error)) {
            this.isSave = false;
            return;
          }

          if (
            this.hasRequiredDealMissing() ||
            this.isRequiredDealApiError(error)
          ) {
            this.showRequiredDealWarningAndOpenSaleForm();
            this.isSave = false;
            return;
          }

          const msg = this.translate.instant("t-error-updating");
          this.errorMsg(msg);
          this.isSave = false;
        },
        () => console.log("complete create property"),
      );
    } else {
      this.isSave = false;
    }
  }

  /**
   * update property
   */
  updateProperty(data: any, isValidate = false) {
    if (this.requiredSubject$.getValue() === false) {
      if (this.propertyMultimediaData?.dataDeleteImages?.length > 0) {
        data.dataProp["imagesDelete"] =
          this.propertyMultimediaData.dataDeleteImages.map((imgd: any) => {
            return { fileName: imgd.fileName, fileId: imgd.fileId };
          });
      }

      if (this.propertyDocumentsData?.dataDeletefiles?.length > 0) {
        data.dataProp["docsDelete"] =
          this.propertyDocumentsData.dataDeletefiles.map((doc: any) => {
            return { fileName: doc.fileName, fileId: doc.id };
          });
      }

      let formData: any = new FormData();

      formData.append("data", JSON.stringify(data.dataProp));

      for (const image of this.propertyMultimediaData.data.images) {
        if (image.isNew) {
          if (
            image.originalFile instanceof File ||
            image.originalFile instanceof Blob
          ) {
            formData.append(
              "images",
              this.renameFile(image.originalFile, `${image.name}${image.id}`),
            );
          } else {
            formData.append(
              "images",
              this.dataUrlToFile(image.img, `${image.name}${image.id}`),
            );
          }
        }
      }
      for (const doc of this.propertyDocumentsData.dataUpload) {
        formData.append("docs", doc);
      }

      this.propertiesService
        .updateProperty(this.propertyUpdate.id, formData)
        .subscribe(
          (data) => {
            if (data.update_property === "ref") {
              const msg = this.translate.instant(
                "t-m-properties.t-this-reference-has-already-been-used",
              );

              this.errorMsg(msg);
            } else {
              this.aiExtractionState.commit(this.propertyUpdate?.id);
              if (isValidate === true) {
                this.propertiesService
                  .validateProperty(this.propertyUpdate.id)
                  .subscribe({
                    next: (updatedProperty) => {
                      this.property = updatedProperty;
                      this.propertyUpdate = updatedProperty;
                      this.isUpdate = true;

                      // Atualiza formulário
                      if (this.propertyForm instanceof FormGroup) {
                        this.propertyForm.patchValue({
                          businessStatus:
                            updatedProperty.propertyBusinessStatus?.id,
                        });
                      }

                      // Feedback visual
                      this.showAlertSuccess(
                        this.translate.instant("t-property-submitted"),
                      );

                      // Atualiza footer em tempo real
                      this.cdr.detectChanges();

                      this.eventService.broadcast("refresh-properties");

                      // Fecha modal
                      this.modalFef.dismiss();
                    },
                    error: () =>
                      this.errorMsg(
                        this.translate.instant("t-property-validation-error"),
                      ),
                  });

                if (data?.resId)
                  this.eventService.broadcast(
                    "new-property-created",
                    data.resId,
                  );
              } else {
                this.eventService.broadcast("refresh-properties");
                if (data?.resId)
                  this.eventService.broadcast(
                    "new-property-created",
                    data.resId,
                  );

                this.modalFef.dismiss();
                const msg = this.translate.instant(
                  "t-m-properties.t-property-create-successfully",
                );

                this.showAlertSuccess(msg);
              }
            }

            if (data?.minimumCommissionPendingValidation) {
              this.notifyPropertiesRealtime(this.propertyUpdate.id);
              this.showAlertSuccess(
                this.translate.instant(
                  "t-property-minimum-commission-validation-sent",
                ),
              );
            }

            this.isSave = false;
          },
          (error) => {
            this.eventService.broadcast("get-data-tab-details");
            if (this.handleMinimumCommissionBlockedError(error)) {
              this.isSave = false;
              return;
            }

            if (
              this.hasRequiredDealMissing() ||
              this.isRequiredDealApiError(error)
            ) {
              this.showRequiredDealWarningAndOpenSaleForm();
              this.isSave = false;
              return;
            }

            // Ativar com a ficha base incompleta: o servidor guardou as
            // alterações mas não ativou, e devolve o que falta (422).
            const missing = extractMissingFields(error);
            if (missing.length) {
              this.showMissingFieldsAlert(missing);
              this.isSave = false;
              return;
            }

            const msg =
              this.getTranslatedErrorMessage(error) ??
              this.translate.instant("t-error-updating");
            this.errorMsg(msg);
            this.isSave = false;
          },
          () => {
            console.log("complete update property");
          },
        );
    } else {
      this.isSave = false;
    }
  }

  // O exception filter global aninha as respostas de HttpException:
  // { message: { statusCode, message: '<chave i18n>', error } }. Quando a
  // mensagem é uma chave t-... com tradução, mostra-a em vez do erro genérico.
  private getTranslatedErrorMessage(error: any): string | null {
    const messagePayload = error?.error?.message;
    const messageKey =
      typeof messagePayload === "string"
        ? messagePayload
        : messagePayload?.message;
    if (typeof messageKey !== "string" || !messageKey.startsWith("t-")) {
      return null;
    }
    const translated = this.translate.instant(messageKey);
    return translated && translated !== messageKey ? translated : null;
  }

  resetForms() {
    this.aiExtractionState.reset();
    this.aiPanelOpen = false;
    this.minimumCommissionValidation = null;
    this.detailsForm = null;
    this.addressForm = null;
    this.propertyAreasNearbyData = null;
    this.propertyCharateristicsData = null;
    this.propertyAdvertisementData = null;
    this.propertyMultimediaData = null;
    this.propertyAgentsData = null;
    this.propertyCostumersContactsData = null;
    this.propertyOwnersContactsData = null;
    this.propertyPortalsData = null;
    this.propertyProposalsData = null;
    this.propertyDocumentsData = null;
  }

  private enabledOrUnknown(ruleKey: string): boolean {
    return this.propertyValidationService.isEnabled(ruleKey);
  }

  private buildCreateUpdateWarnings<T>(
    defs: WarnDef<T>[],
    data: T,
    isUpdate: boolean,
  ): ErrorItem[] {
    const error: ErrorItem[] = [];

    for (const d of defs) {
      if (!this.enabledOrUnknown(d.ruleKey)) continue;

      if (!isUpdate || d.invalidOnUpdate(data)) {
        error.push({ key: d.uiKey, type: { warning: true } });
      }
    }

    return error;
  }

  private handleMinimumCommissionBlockedError(error: any): boolean {
    const payload = error?.error?.code
      ? error?.error
      : error?.error?.message && typeof error?.error?.message === "object"
        ? error?.error?.message
        : null;

    if (payload?.code !== "PROPERTY_MINIMUM_COMMISSION_BLOCKED") {
      return false;
    }

    const minimumRaw = payload?.minimumSaleCommission;
    const minimum = Number(
      `${minimumRaw ?? 0}`.replace(/\s/g, "").replace(",", "."),
    );

    this.minimumCommissionValidation = {
      active: true,
      minimum: Number.isFinite(minimum) ? minimum : null,
      action: "BLOCK_SAVE",
    };

    this.nabTabActive = 1;
    this.activeIdChangeNabTab();
    this.cdr.detectChanges();

    return true;
  }

  private notifyPropertiesRealtime(propertyId: string) {
    const lang = this.cookiesService.get("lang") || "pt";
    this.notificationService.notifyProperties({ propertyId, lang });
    this.eventService.broadcast("update-notifications");
  }

  private parseNumericValue(value: any): number {
    if (value === undefined || value === null || value === "") {
      return 0;
    }

    const parsed = Number(
      `${value}`.replace(/\s/g, "").replace(",", ".").replace("%", ""),
    );

    return Number.isFinite(parsed) ? parsed : 0;
  }

  private isPercentageCommissionValue(value: any): boolean {
    return value === true || `${value}`.toLowerCase() === "true";
  }

  private getCommissionPercentForMinimumRule(dataProp: any): number {
    const commission = this.parseNumericValue(dataProp?.saleCommission);

    if (this.isPercentageCommissionValue(dataProp?.isPercentageCommission)) {
      return commission;
    }

    const saleValue = this.parseNumericValue(dataProp?.saleValue);
    const price = this.parseNumericValue(
      dataProp?.price ?? this.detailsForm?.data?.price,
    );
    const propertyPrice = saleValue > 0 ? saleValue : price;

    if (propertyPrice <= 0) {
      return 0;
    }

    return (commission / propertyPrice) * 100;
  }

  private isRentBusinessTypeOnFront(dataProp: any): boolean {
    const typeRent = this.dataToFormInitDetails?.typeRent;
    const businessType =
      dataProp?.businessType ?? this.detailsForm?.data?.businessType;

    if (typeRent === null || typeRent === undefined) {
      return false;
    }

    return Number(businessType) === Number(typeRent);
  }

  private isMinimumCommissionApprovedForProperty(dataProp: any): boolean {
    return (
      dataProp?.minimumCommissionApproved === true ||
      this.currentProperty?.details?.minimumCommissionApproved === true
    );
  }

  private shouldBlockByMinimumCommissionOnFront(dataProp: any): boolean {
    const commissionsConfig = this.dataToFormInitDetails?.commissions;
    const action = commissionsConfig?.minimumCommissionViolationAction;
    const minimum = Number(
      `${commissionsConfig?.minimumSaleCommission ?? 0}`
        .replace(/\s/g, "")
        .replace(",", "."),
    );

    if (
      !["BLOCK_SAVE", "SEND_TO_MASTER_VALIDATION"].includes(action) ||
      !Number.isFinite(minimum) ||
      minimum <= 0
    ) {
      return false;
    }

    if (
      this.isRentBusinessTypeOnFront(dataProp) ||
      this.isMinimumCommissionApprovedForProperty(dataProp)
    ) {
      this.minimumCommissionValidation = null;
      return false;
    }

    const commission = this.getCommissionPercentForMinimumRule(dataProp);

    if (Number.isFinite(commission) && commission >= minimum) {
      this.minimumCommissionValidation = null;
      return false;
    }

    if (action === "SEND_TO_MASTER_VALIDATION") {
      this.minimumCommissionValidation = {
        active: true,
        minimum,
        action: "SEND_TO_MASTER_VALIDATION",
      };
      return false;
    }

    this.minimumCommissionValidation = {
      active: true,
      minimum,
      action: "BLOCK_SAVE",
    };
    this.nabTabActive = 1;
    this.activeIdChangeNabTab();
    this.cdr.detectChanges();
    this.isSave = false;

    return true;
  }

  private buildDocumentsErrors(documents: any): any[] {
    const errors: any[] = [];

    // Documentos obrigatórios por tipo de imóvel: o separador de documentos
    // publica em `propertyDocumentsData` o que falta (só no modo tipado);
    // aqui só se preserva esse aviso quando o pai recalcula.
    const missingTypes: string[] =
      this.propertyDocumentsData?.typedMode
        ? this.propertyDocumentsData?.requiredMissingNames ?? []
        : [];
    if (missingTypes.length > 0) {
      errors.push({
        key: "documents.types",
        type: { warning: true },
        missing: [...missingTypes],
      });
    }

    if (!this.enabledOrUnknown("documents.mediaMin")) return errors;

    const min = this.propertyValidationService.minValue("documents.mediaMin");
    const activeCount = documents?.length ?? 0;

    if (activeCount < min) {
      errors.push({
        key: "documents.mediaMin",
        type: { warning: true },
        valueMin: min,
        activeCount,
      });
    }
    return errors;
  }

  hasDocumentsError(key: string): boolean {
    return (this.propertyDocumentsData?.errors ?? []).some(
      (e: any) => e?.key === key,
    );
  }

  documentsMissingTypeNames(): string {
    const err = (this.propertyDocumentsData?.errors ?? []).find(
      (e: any) => e?.key === "documents.types",
    );
    return (err?.missing ?? []).join(", ");
  }

  private countActiveMedia(multimedia: any): number {
    const images = (multimedia?.images ?? []).filter((img: any) => {
      const active = img?.status === undefined ? true : img?.status === true;

      return active;
    }).length;

    const videos = (multimedia?.videos ?? []).filter((video: any) => {
      const active =
        video?.status === undefined ? true : video?.status === true;

      return active;
    }).length;

    return images + videos;
  }

  private isCkEmpty(value: any): boolean {
    if (value === null || value === undefined) return true;

    const html = String(value);

    const text = html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\u00A0/g, " ")
      .trim();

    return text.length === 0;
  }

  /**
   * Avisos do separador CMI.
   *
   * Os campos vivem no componente partilhado app-mediation-contract e chegam
   * aqui pelo PropertyDataService; o catálogo de requisitos do MASTER expõe-os
   * como `cmi.*`. Regra desligada na entidade não gera aviso nenhum — disso
   * trata o `enabledOrUnknown` dentro de `buildCreateUpdateWarnings`.
   *
   * Avalia sempre pelo valor (`isUpdate = true`), também num imóvel novo: o
   * separador do CMI preenche-se antes de gravar, e um aviso que não desaparece
   * ao preencher o campo não serve para nada.
   */
  createCmiErrors(): ErrorItem[] {
    const data = this.propertyData.currentCmiValue ?? {};

    const defs: WarnDef<any>[] = [
      {
        uiKey: "contractNumber",
        ruleKey: "cmi.contractNumber",
        invalidOnUpdate: (d) => !d?.contractNumber,
      },
      {
        uiKey: "startDateMediation",
        ruleKey: "cmi.startDateMediation",
        invalidOnUpdate: (d) => !d?.startDateMediation,
      },
      {
        uiKey: "endDateMediation",
        ruleKey: "cmi.endDateMediation",
        invalidOnUpdate: (d) => !d?.endDateMediation,
      },
    ];

    return this.buildCreateUpdateWarnings(defs, data, true);
  }

  createDetailsErrors(property: any) {
    const isUpdate = !!property;
    const data = this.detailsForm?.data ?? {};
    const getEcKeyById = (ecId: any) =>
      this.dataToFormInitDetails?.ec?.find((s: any) => s.id === ecId)?.key;
    const isEcNumberOptional = (ecKey?: string) =>
      ["Exempted", "Unavailable", "In evaluation"].includes(ecKey ?? "");

    const errors: ErrorItem[] = isUpdate
      ? []
      : [{ key: "reference", type: { required: true } }];

    const propertyTypeId = this.dataToFormInitDetails?.propertyTypes?.find(
      (s: any) => s.description === "---",
    )?.id;

    const conditionId = this.dataToFormInitDetails?.conditions?.find(
      (s: any) => s.description === "---",
    )?.id;

    const businessStatusId = this.dataToFormInitDetails?.businessStatus?.find(
      (s: any) => s.description === "---",
    )?.id;

    const ecId = this.dataToFormInitDetails?.ec?.find(
      (s: any) => s.description === "---",
    )?.id;

    const businessTypeId = this.dataToFormInitDetails?.businessTypes?.find(
      (s: any) => s.description === "---",
    )?.id;

    const defs: WarnDef<any>[] = [
      {
        uiKey: "propertyType",
        ruleKey: "details.propertyType",
        invalidOnUpdate: (d) =>
          !!propertyTypeId && d?.propertyType === propertyTypeId,
      },
      {
        uiKey: "condition",
        ruleKey: "details.condition",
        invalidOnUpdate: (d) => !!conditionId && d?.condition === conditionId,
      },
      {
        uiKey: "businessStatus",
        ruleKey: "details.businessStatus",
        invalidOnUpdate: (d) =>
          !!businessStatusId && d?.businessStatus === businessStatusId,
      },
      {
        uiKey: "price",
        ruleKey: "details.price",
        invalidOnUpdate: (d) => !d?.price,
      },
      // {
      //   uiKey: "rentalPrice",
      //   ruleKey: "details.rentalPrice",
      //   invalidOnUpdate: (d) => !d?.rentalPrice,
      // },
      {
        uiKey: "ec",
        ruleKey: "details.ec",
        invalidOnUpdate: (d) => !!ecId && d?.ec === ecId,
      },
      {
        uiKey: "ecNumber",
        ruleKey: "details.ecNumber",
        invalidOnUpdate: (d) => {
          const ecKey = getEcKeyById(d?.ec);
          const hasEcNumber = !!String(d?.ecNumber ?? "").trim();

          return !hasEcNumber && !isEcNumberOptional(ecKey);
        },
      },
      {
        uiKey: "businessType",
        ruleKey: "details.businessType",
        invalidOnUpdate: (d) =>
          !!businessTypeId && d?.businessType === businessTypeId,
      },
    ];

    errors.push(...this.buildCreateUpdateWarnings(defs, data, isUpdate));
    return errors;
  }

  createAddressErrors(property: any) {
    const isUpdate = !!property;
    const data = this.addressForm?.data ?? {};

    const defs: WarnDef<any>[] = [
      {
        uiKey: "country",
        ruleKey: "address.country",
        invalidOnUpdate: (d) => !!d?.country && d?.countryName === "---",
      },
      {
        uiKey: "region",
        ruleKey: "address.region",
        invalidOnUpdate: (d) => !!d?.region && d?.regionName === "---",
      },
      {
        uiKey: "district",
        ruleKey: "address.district",
        invalidOnUpdate: (d) => !!d?.district && d?.districtName === "---",
      },
      {
        uiKey: "county",
        ruleKey: "address.county",
        invalidOnUpdate: (d) => !!d?.county && d?.countyName === "---",
      },
      {
        uiKey: "parish",
        ruleKey: "address.parish",
        invalidOnUpdate: (d) => !!d?.parish && d?.parishName === "---",
      },
      {
        uiKey: "address",
        ruleKey: "address.address",
        invalidOnUpdate: (d) => !d?.address,
      },
      {
        uiKey: "zip-code",
        ruleKey: "address.zipCode",
        invalidOnUpdate: (d) => !d?.zipCode,
      },
    ];

    return this.buildCreateUpdateWarnings(defs, data, isUpdate);
  }

  private countFilledDivisions(d: any): number {
    return Object.keys(d ?? {}).reduce((acc, key) => {
      const m = /^division(\d+)$/.exec(key);
      if (!m) return acc;

      const v = Number(d?.[key] ?? 0);

      return acc + (v > 0 ? 1 : 0);
    }, 0);
  }

  createAreasErrors(property: any) {
    const isUpdate = !!property;
    const data = this.propertyAreasNearbyData?.data ?? {};

    const defs: WarnDef<any>[] = [
      {
        uiKey: "grossArea",
        ruleKey: "areasNearby.grossArea",
        invalidOnUpdate: (d) =>
          d?.grossArea === null ||
          d?.grossArea === undefined ||
          d?.grossArea === "",
      },
      {
        uiKey: "usefulArea",
        ruleKey: "areasNearby.usefulArea",
        invalidOnUpdate: (d) =>
          d?.usefulArea === null ||
          d?.usefulArea === undefined ||
          d?.usefulArea === "",
      },
      {
        uiKey: "grossDependentArea",
        ruleKey: "areasNearby.grossDependentArea",
        invalidOnUpdate: (d) =>
          d?.grossDependentArea === null ||
          d?.grossDependentArea === undefined ||
          d?.grossDependentArea === "",
      },
      {
        uiKey: "grossPrivateArea",
        ruleKey: "areasNearby.grossPrivateArea",
        invalidOnUpdate: (d) =>
          d?.grossPrivateArea === null ||
          d?.grossPrivateArea === undefined ||
          d?.grossPrivateArea === "",
      },
      {
        uiKey: "landArea",
        ruleKey: "areasNearby.landArea",
        invalidOnUpdate: (d) =>
          d?.landArea === null ||
          d?.landArea === undefined ||
          d?.landArea === "",
      },
      {
        uiKey: "divisions",
        ruleKey: "areasNearby.divisions",
        invalidOnUpdate: (d) => {
          const enabled = this.enabledOrUnknown("areasNearby.divisions");

          if (!enabled) return false;

          const idToCompare = this.detailsForm?.data?.propertyType2
            ? this.detailsForm?.data?.propertyType2
            : this.detailsForm?.data?.propertyType;
          const isApartmentOrHouse =
            this.dataToFormInitDetails?.propertyTypes?.find(
              (s: any) =>
                s.id === idToCompare &&
                (s?.groupMainDescription === "Apartments" ||
                  s?.groupMainDescription === "Houses" ||
                  s?.groupMainDescription === "---"),
            );
          if (!isApartmentOrHouse) return false;

          const min = this.propertyValidationService.minValue(
            "areasNearby.divisions",
          );

          const filledCount = this.countFilledDivisions(d);
          return filledCount < min;
        },
      },
    ];

    return this.buildCreateUpdateWarnings(defs, data, isUpdate);
  }

  private buildMultimediaErrors(multimedia: any): any[] {
    if (!this.enabledOrUnknown("multimedia.mediaMin")) return [];

    const min = this.propertyValidationService.minValue("multimedia.mediaMin");
    const count = this.countActiveMedia(multimedia);

    return count >= min
      ? []
      : [
        {
          key: "mediaMin",
          type: { warning: true },
          valueMin: min,
          activeCount: count,
        },
      ];
  }

  createAdvertisementErrors(property: any) {
    const errors: ErrorItem[] = [];

    const titleEnabled = this.enabledOrUnknown("advertisement.title");
    const descEnabled = this.enabledOrUnknown("advertisement.description");

    const langs = this.dataToFormInitAdvertisement?.langs ?? [];

    const mainLang = langs?.find(
      (lang: any) =>
        this.propertyAdvertisementData?.data?.[`lang${lang.id}_main`],
    )?.id;

    const titleKey = `lang${mainLang}_title`;
    const descKey = `lang${mainLang}_description`;

    if (titleEnabled) {
      const title = this.propertyAdvertisementData?.data?.[titleKey];

      const titleEmpty =
        title === null ||
        title === undefined ||
        String(title).trim().length === 0 ||
        title === "N/A";

      if (titleEmpty || !mainLang) {
        errors.push({ key: "title", type: { warning: true } });
      }
    }

    if (descEnabled) {
      const desc = this.propertyAdvertisementData?.data?.[descKey];

      const empty = this.isCkEmpty(desc);

      if (empty || !mainLang) {
        errors.push({ key: "description", type: { warning: true } });
      }
    }

    return errors;
  }

  private refreshCmiWarnings(): void {
    this.propertyCmiData.errors = this.createCmiErrors();
    this.propertyCmiData.valid = this.propertyCmiData.errors.length === 0;
  }

  private refreshOwnersWarning(): boolean {
    if (!this.propertyOwnersContactsData) return false;

    const errors = this.createContactsErrors();

    this.propertyOwnersContactsData.errors = errors;

    this.propertyOwnersContactsData.valid =
      this.propertyOwnersContactsData.errors.length === 0;

    return errors.some(
      (error: any) => error.key === "owners" && !!error.type?.warning,
    );
  }

  createContactsErrors(): any[] {
    if (!this.enabledOrUnknown("contacts.owner")) return [];

    if (!this.requiredOwner) return [];

    const owners = this.propertyOwnersContactsData?.data?.owners ?? [];

    return owners.length > 0
      ? []
      : [{ key: "owners", type: { warning: true } }];
  }

  base64ToFile(base64Image: string): Blob {
    const split = base64Image.split(",");
    const type = split[0].replace("data:", "").replace(";base64", "");
    const byteString = atob(split[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
  }

  dataUrlToFile(dataUrl: any, filename: any) {
    const split = dataUrl.split(",");
    const mime = split[0].match(/:(.*?);/)[1];
    const byteString = atob(split[1]);
    let ab = byteString.length;
    const ia = new Uint8Array(ab);
    while (ab--) {
      ia[ab] = byteString.charCodeAt(ab);
    }
    return new File([ia], filename, { type: mime });
  }

  renameFile(file: File | Blob, newName: string): File {
    const newFile = new File([file], newName, {
      type: file.type,
    });
    return newFile;
  }

  loadJs() {
    const scriptLoadBs: any = document.querySelector("#bs-js");
    if (!scriptLoadBs) {
      const node = document.createElement("script");
      node.src = "assets/libs/bootstrap/js/bootstrap.bundle.min.js";
      node.type = "text/javascript";
      node.async = true;
      node.id = "bs-js";
      document.body.appendChild(node);
    }
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translate.instant("t-something-wrong"),
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-close"),
    });
  }

  /**
   * show sweet alert success
   * @param position modal content
   */
  showAlertWarning(msg: string) {
    Swal.fire({
      icon: "warning",
      title: msg,
      validationMessage: this.translate.instant(
        "t-property-validation-message",
      ),
      showConfirmButton: false,
      timer: 1500,
    });
  }

  showAlertSuccess(msg: string) {
    Swal.fire({
      icon: "success",
      title: msg,
      validationMessage: this.translate.instant(
        "t-property-validation-message",
      ),
      showConfirmButton: false,
      timer: 1500,
    });
  }

  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  private isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  shouldShowGenerateRefButton(): boolean {
    // "Ver como" é só de leitura.
    if (this.permissionsService.isReadOnly) return false;
    if (this.isValidatedEditLockedForCurrentUser()) {
      return false;
    }

    const roleName =
      this.user?.role?.name ||
      this.loginUser?.role?.name ||
      this.permissionsService.currentRole;

    if (!this.permissionsService.isAgent(roleName) && !this.property) {
      return false;
    }

    return this.detailsForm?.data?.isTempReference === true;
  }

  shouldShowValidateButton(): boolean {
    // "Ver como" é só de leitura.
    if (this.permissionsService.isReadOnly) return false;
    const property = this.currentProperty;

    if (this.isValidatedEditLockedForCurrentUser()) {
      return false;
    }

    // Apenas agentes podem validar
    if (!this.permissionsService.isAgent(this.permissionsService.currentRole)) {
      return false;
    }

    if (this.detailsForm?.data?.isTempReference === true) {
      return false;
    }

    // Sempre mostra o botão, mesmo antes de salvar
    if (!property || !property.id) {
      return true;
    }

    if (!this.permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES')) {
      return false;
    }

    const status =
      property.details?.businessStatusData?.code ||
      this.getStatusCodeFromId(property.propertyBusinessStatusId);

    // Mostrar se em prospecção ou recusado
    if (
      status === "PROSPECTING" ||
      status === "REMOVED" ||
      status === "DECLINED"
    ) {
      return true;
    }

    // Ocultar se já está para validação
    if (status === "TO_VALIDATE") {
      return false;
    }

    return false;
  }

  shouldShowApproveButton(): boolean {
    // "Ver como" é só de leitura.
    if (this.permissionsService.isReadOnly) return false;
    const property = this.currentProperty;

    if (!property) return false;
    const status = property.details?.businessStatusData?.code;
    if (status !== "TO_VALIDATE") return false;

    const isMinimumCommissionFlow =
      property?.minimumCommissionPendingValidation === true ||
      property?.details?.minimumCommissionPendingValidation === true;

    if (isMinimumCommissionFlow) {
      const roleName =
        this.user?.role?.name ??
        this.loginUser?.role?.name ??
        this.permissionsService.currentRole;

      return this.permissionsService.isRealMaster(roleName);
    }

    const isApprover = this.permissionsService.checkFullPermission(
      "APPROVE_PROPERTIES",
      property.details?.store,
      property.mainAgent,
    );

    if (!isApprover) return false;

    return true;
  }

  // Imóvel já aprovado após validação: só MASTER ou quem tem a permissão
  // EDIT_PROPERTIES_AFTER_VALIDATION pode editar; os restantes ficam em modo consulta.
  isValidatedEditLockedForCurrentUser(): boolean {
    if (!this.currentProperty?.validatedAt) {
      return false;
    }

    return !this.permissionsService.hasPermission(
      "EDIT_PROPERTIES_AFTER_VALIDATION",
    );
  }

  isMinimumCommissionReviewLockedForCurrentUser(): boolean {
    const property = this.currentProperty;
    const isMinimumCommissionFlow =
      property?.minimumCommissionPendingValidation === true ||
      property?.details?.minimumCommissionPendingValidation === true;

    if (!isMinimumCommissionFlow) {
      return false;
    }

    const roleName =
      this.user?.role?.name ??
      this.loginUser?.role?.name ??
      this.permissionsService.currentRole;

    return !this.permissionsService.isRealMaster(roleName);
  }

  shouldShowRejectButton(): boolean {
    const property = this.currentProperty;
    if (!property) return false;
    const status = property.details?.businessStatusData?.code;
    if (status !== "TO_VALIDATE") return false;

    const isMinimumCommissionFlow =
      property?.minimumCommissionPendingValidation === true ||
      property?.details?.minimumCommissionPendingValidation === true;

    if (isMinimumCommissionFlow) {
      const roleName =
        this.user?.role?.name ??
        this.loginUser?.role?.name ??
        this.permissionsService.currentRole;

      return this.permissionsService.isRealMaster(roleName);
    }

    const isRejector = this.permissionsService.checkFullPermission(
      "REJECT_PROPERTIES",
      property.details?.store,
      property.mainAgent,
    );

    if (!isRejector) return false;

    return true;
  }

  getStatusCodeFromId(id: string): string | null {
    const found = this.statusList?.find((s) => s.id === id);
    return found?.code || null;
  }

  openRejectModal() {
    Swal.fire({
      title: this.translate.instant("t-property-reject-title"),
      input: "textarea",
      inputLabel: this.translate.instant("t-property-reject-label"),
      inputPlaceholder: this.translate.instant("t-property-reject-placeholder"),
      inputAttributes: { "aria-label": "Type your message here" },
      showCancelButton: true,
      confirmButtonText: this.translate.instant("t-property-reject-confirm"),
      cancelButtonText: this.translate.instant("t-cancel"),
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        this.rejectProperty(result.value);
      }
    });
  }

  maybeShowApprovedAlert(): void {
    const roleName =
      this.user?.role?.name ?? this.permissionsService.currentRole;

    const status = this.currentProperty?.details?.businessStatusData?.code;

    if (this.permissionsService.isAgent(roleName) && status === "AVAILABLE") {
      this.showApprovedAlert = true;

      clearTimeout(this.approvedAlertTimer);

      this.approvedAlertTimer = setTimeout(() => {
        this.cdr.markForCheck?.();
      }, 8000);
    } else {
      this.showApprovedAlert = false;
    }
  }

  generateReference() {
    if (!this.property) {
      this.saveProperty(false, false, true);
    } else {
      const storeId = this.detailsForm.data?.store || undefined;
      const propertyTypeId = this.detailsForm.data?.propertyType || undefined;
      const agMain =
        this.propertyAgentsData?.find((agent: any) => agent.isMain) ||
        undefined;
      const agentId = agMain?.id;
      this.propertiesService
        .previewAndSaveReference(
          this.property?.id,
          storeId,
          agentId,
          propertyTypeId,
        )
        .subscribe({
          next: (data) => {
            this.detailsForm.data.reference = data.reference;
            this.detailsForm.data.isTempReference = false;
            this.eventService.broadcast("refresh-reference", data.reference);
            this.propertyData.seedFromCMI({
              contractNumber: data.reference ?? null,
              startDateMediation:
                this.propertyData.currentCmiValue?.startDateMediation ?? null,
              endDateMediation:
                this.propertyData.currentCmiValue?.endDateMediation ?? null,
              autoRenewal:
                this.propertyData.currentCmiValue?.autoRenewal ?? null,
            });
            this.eventService.broadcast("refresh-properties");
            void this.afterReferenceGenerated(data?.reference ?? "");
          },
          error: (err) => {
            // 422 PROPERTY_REQUIRED_FIELDS_INCOMPLETE: o servidor diz QUAIS
            // os campos da ficha que faltam.
            const missing = extractMissingFields(err);
            if (missing.length) {
              this.showMissingFieldsAlert(missing);
              return;
            }
            this.errorMsg(this.translate.instant("t-error-updating"));
          },
        });
    }
  }

  private showMissingFieldsAlert(missing: any[]): void {
    Swal.fire({
      title: this.translate.instant("t-listing-detail-validation-blocked"),
      html: missingFieldsHtml(missing, this.translate),
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-close"),
    });
  }

  /**
   * Referência atribuída: confirma-a e, havendo CMI configurado para este
   * imóvel e permissão para o gerar, propõe gerar já — abre o separador de
   * mediação e o gerador (o passo seguinte, e o motivo da referência).
   */
  /**
   * "Guardar e gerar referência": o imóvel acabou de nascer (provisório) e a
   * referência definitiva pede-se agora pelo mesmo endpoint do botão da ficha
   * já guardada — o servidor aplica a lista base e devolve o que falta. A
   * ficha reabre-se em qualquer caso, já com a referência quando correu bem.
   */
  private generateReferenceForCreated(propertyId: string): void {
    const storeId = this.detailsForm?.data?.store || undefined;
    const propertyTypeId = this.detailsForm?.data?.propertyType || undefined;
    const agentId = this.propertyAgentsData?.find(
      (agent: any) => agent?.isMain,
    )?.id;
    const reopen = () => {
      this.openModaltSubject$.next(6);
      this.openModal({ id: propertyId } as any, this.content);
    };

    this.modalFef.dismiss();
    this.propertiesService
      .previewAndSaveReference(propertyId, storeId, agentId, propertyTypeId)
      .subscribe({
        next: (data) => {
          this.eventService.broadcast("refresh-properties");
          reopen();
          void this.afterReferenceGenerated(data?.reference ?? "", propertyId);
        },
        error: (err) => {
          reopen();
          const missing = extractMissingFields(err);
          if (missing.length) {
            this.showMissingFieldsAlert(missing);
            return;
          }
          this.errorMsg(this.translate.instant("t-error-updating"));
        },
      });
  }

  private async afterReferenceGenerated(
    reference: string,
    createdPropertyId: string | null = null,
  ): Promise<void> {
    await Swal.fire({
      title: this.translate.instant("t-listing-detail-reference-generated"),
      text: this.translate.instant("t-property-reference-assigned", { reference }),
      icon: "success",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-close"),
    });

    const propertyId = createdPropertyId ?? this.property?.id ?? this.propertyId;
    if (!propertyId || !this.permissionsService.hasPermission("CAN_GENERATE_CMI")) {
      return;
    }

    let available = false;
    try {
      const availability = await this.filesService
        .getCmiAvailability({ propertyId: String(propertyId) })
        .toPromise();
      available = availability?.available === true;
    } catch {
      available = false;
    }
    if (!available) return;

    const generate = await Swal.fire({
      title: this.translate.instant("t-generate-cmi-now"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "rgb(54, 69, 116)",
      cancelButtonColor: "#74788d",
      confirmButtonText: this.translate.instant("t-yes"),
      cancelButtonText: this.translate.instant("t-no"),
    });
    if (!generate.isConfirmed) return;

    this.nabTabActive = 13;
    this.activeIdChangeNabTab();
    this.openCmiGeneratorWhenRendered();
  }

  /**
   * O conteúdo do separador só existe depois de o `ngbNav` o ativar e de a
   * deteção de alterações correr — o `ViewChild` fica `undefined` até lá.
   * Tenta algumas vezes com um intervalo curto e desiste em silêncio.
   */
  private openCmiGeneratorWhenRendered(attempt = 0): void {
    setTimeout(() => {
      if (this.modalClosed) return;
      if (this.mediationContract) {
        this.mediationContract.openGeneratorWhenReady();
        return;
      }
      if (attempt < 10) this.openCmiGeneratorWhenRendered(attempt + 1);
    }, 150);
  }

  /**
   * O CMI gerado no separador de mediação atribuiu a referência definitiva
   * (o imóvel tinha referência temporária): recarrega-se a ficha para trazer
   * a referência e o número de contrato, e avisa-se o separador de detalhes.
   */
  onCmiReferenceAssigned(): void {
    const propertyId = this.property?.id ?? this.propertyId;
    if (!propertyId) return;
    this.eventService.broadcast("refresh-properties");

    this.propertiesService.findOne(propertyId).subscribe({
      next: (data: any) => {
        const reference = data?.details?.reference ?? data?.reference ?? null;
        if (this.detailsForm?.data) {
          if (reference) this.detailsForm.data.reference = reference;
          this.detailsForm.data.isTempReference = false;
        }
        if (this.property) this.property.reference = reference ?? this.property.reference;
        if (reference) {
          this.eventService.broadcast("refresh-reference", reference);
        }
        this.propertyData.seedFromCMI({
          contractNumber:
            data?.details?.contractNumber ??
            this.propertyData.currentCmiValue?.contractNumber ??
            null,
          startDateMediation:
            data?.details?.startDateMediation ??
            this.propertyData.currentCmiValue?.startDateMediation ??
            null,
          endDateMediation:
            data?.details?.endDateMediation ??
            this.propertyData.currentCmiValue?.endDateMediation ??
            null,
          autoRenewal:
            data?.details?.autoRenewal ??
            this.propertyData.currentCmiValue?.autoRenewal ??
            null,
        });
        this.checkWarning();
      },
      error: () => undefined,
    });
  }

  canSaveProperty() {
    // "Ver como" é só de leitura.
    if (this.permissionsService.isReadOnly) return false;
    if (this.isMinimumCommissionReviewLockedForCurrentUser()) {
      return false;
    }

    if (this.isValidatedEditLockedForCurrentUser()) {
      return false;
    }

    const store =
      this.propertyUpdate?.store?.id ||
      this.propertyUpdate?.store ||
      this.property?.store?.id ||
      this.property?.store;
    return (
      (this.loginUser?.id === this.propertyUpdate?.mainAgent ||
        this.permissionsService.canEditProperty(
          this.loginUser,
          store,
          !this.propertyUpdate ? true : false,
          this.propertyUpdate ? this.propertyUpdate?.mainAgent : null,
        ) ||
        !this.currentProperty?.id) &&
      (!this.currentProperty?.id ||
        this.currentProperty?.details?.businessStatusData?.code !==
        "TO_VALIDATE")
    );
  }

  ngOnDestroy(): void {
    clearTimeout(this.formWatchTimeout);
    this.disconnectFormWatchObserver();
    this.subscriptions.unsubscribe();
    this.subscriptionDataTabAgents.unsubscribe();
    this.subscriptionCkeckWarning.unsubscribe();
  }
}
